export const featuredProducts = [
  {
    id: 1,
    name: 'Premium Laptop - MacBook Pro 16"',
    price: 2499.99,
    category: 'Electronics',
    description: 'High-performance laptop with M3 chip, 32GB RAM, perfect for professionals',
    image: 'https://public.readdy.ai/ai/img_res/8cf573db4506ea9d1082fa7df1955e03.jpg',
    commission: 749.99,
    recurring: false,
  },
  {
    id: 2,
    name: 'Luxury Designer Watch Collection',
    price: 1899.99,
    category: 'Fashion',
    description: 'Premium Swiss-made timepiece with automatic movement and sapphire crystal',
    image: 'https://readdy.ai/api/search-image?query=elegant%20luxury%20wristwatch%20with%20silver%20metal%20band%20and%20sophisticated%20dial%20displayed%20on%20clean%20white%20surface%20with%20soft%20professional%20studio%20lighting%20highlighting%20the%20premium%20craftsmanship%20and%20refined%20details%20of%20the%20timepiece&width=600&height=600&seq=watch1&orientation=squarish',
    commission: 569.99,
    recurring: false,
  },
  {
    id: 3,
    name: 'Professional Camera Kit - Sony A7 IV',
    price: 2799.99,
    category: 'Electronics',
    description: 'Full-frame mirrorless camera with 3 lenses, perfect for photography professionals',
    image: 'https://readdy.ai/api/search-image?query=professional%20mirrorless%20camera%20with%20attached%20lens%20displayed%20on%20pristine%20white%20surface%20showing%20the%20camera%20body%20controls%20and%20premium%20build%20quality%20in%20bright%20studio%20lighting%20with%20clean%20minimalist%20background&width=600&height=600&seq=camera1&orientation=squarish',
    commission: 839.99,
    recurring: false,
  },
  {
    id: 4,
    name: 'Gourmet Food Subscription Box',
    price: 149.99,
    category: 'Gourmet',
    description: 'Monthly delivery of artisan cheeses, wines, and gourmet treats from around the world',
    image: 'https://readdy.ai/api/search-image?query=elegant%20gourmet%20food%20subscription%20box%20filled%20with%20artisan%20cheeses%20fine%20wines%20fresh%20fruits%20and%20premium%20delicacies%20beautifully%20arranged%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20and%20minimalist%20styling&width=600&height=600&seq=food1&orientation=squarish',
    commission: 44.99,
    recurring: true,
    recurringNote: 'Monthly',
  },
  {
    id: 5,
    name: 'Luxury Maldives Vacation Package',
    price: 4999.99,
    category: 'Travel',
    description: '7-day all-inclusive resort stay with overwater villa, spa treatments, and activities',
    image: 'https://readdy.ai/api/search-image?query=stunning%20overwater%20villa%20bungalow%20with%20thatched%20roof%20over%20crystal%20clear%20turquoise%20ocean%20water%20in%20tropical%20paradise%20with%20wooden%20deck%20and%20lounge%20chairs%20under%20bright%20blue%20sky%20representing%20luxury%20vacation%20destination&width=600&height=600&seq=vacation1&orientation=squarish',
    commission: 1499.99,
    recurring: false,
  },
  {
    id: 6,
    name: 'Premium Home Gym Equipment Set',
    price: 1599.99,
    category: 'Health & Fitness',
    description: 'Complete home gym with adjustable dumbbells, bench, and resistance bands',
    image: 'https://readdy.ai/api/search-image?query=modern%20home%20gym%20equipment%20set%20with%20adjustable%20dumbbells%20weight%20bench%20and%20fitness%20accessories%20arranged%20neatly%20on%20clean%20white%20floor%20in%20bright%20minimalist%20space%20with%20professional%20lighting&width=600&height=600&seq=gym1&orientation=squarish',
    commission: 479.99,
    recurring: false,
  },
];

export const allProducts = [
  ...featuredProducts,
  
  // ========== TRENDING UNDER $50 - NEW HOT ITEMS ==========
  {
    id: 159,
    name: 'Wireless Earbuds - Premium Sound',
    price: 29.99,
    category: 'Electronics',
    description: 'True wireless earbuds with noise cancellation and 24-hour battery life',
    image: 'https://readdy.ai/api/search-image?query=modern%20wireless%20earbuds%20in%20sleek%20white%20charging%20case%20with%20minimalist%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20quality%20compact%20technology&width=600&height=600&seq=wireless-earbuds-trending&orientation=squarish',
    commission: 8.99,
    recurring: false,
  },
  {
    id: 160,
    name: 'Phone Case with Card Holder',
    price: 12.99,
    category: 'Electronics',
    description: 'Slim leather phone case with built-in card slots and kickstand',
    image: 'https://readdy.ai/api/search-image?query=elegant%20leather%20phone%20case%20in%20black%20with%20card%20holder%20slots%20and%20sleek%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20practical%20functionality&width=600&height=600&seq=phone-case-card&orientation=squarish',
    commission: 3.89,
    recurring: false,
  },
  {
    id: 161,
    name: 'LED Strip Lights - 16.4ft',
    price: 19.99,
    category: 'Home & Living',
    description: 'Color-changing LED lights with remote control and music sync',
    image: 'https://readdy.ai/api/search-image?query=colorful%20LED%20strip%20lights%20showing%20vibrant%20rainbow%20colors%20with%20remote%20control%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20demonstrating%20smart%20home%20lighting&width=600&height=600&seq=led-strip-lights&orientation=squarish',
    commission: 5.99,
    recurring: false,
  },
  {
    id: 162,
    name: 'Portable Power Bank - 20000mAh',
    price: 24.99,
    category: 'Electronics',
    description: 'Fast charging power bank with dual USB ports and LED display',
    image: 'https://readdy.ai/api/search-image?query=sleek%20portable%20power%20bank%20in%20matte%20black%20with%20LED%20display%20and%20USB%20ports%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20modern%20charging%20technology&width=600&height=600&seq=power-bank-portable&orientation=squarish',
    commission: 7.49,
    recurring: false,
  },
  {
    id: 163,
    name: 'Minimalist Watch - Unisex',
    price: 24.99,
    category: 'Fashion',
    description: 'Elegant minimalist watch with leather strap and Japanese movement',
    image: 'https://readdy.ai/api/search-image?query=minimalist%20wristwatch%20with%20clean%20white%20dial%20and%20brown%20leather%20strap%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20elegant%20simple%20design&width=600&height=600&seq=minimalist-watch-unisex&orientation=squarish',
    commission: 7.49,
    recurring: false,
  },
  {
    id: 164,
    name: 'Crossbody Phone Bag',
    price: 18.99,
    category: 'Fashion',
    description: 'Stylish crossbody bag for phone with multiple compartments',
    image: 'https://readdy.ai/api/search-image?query=trendy%20crossbody%20phone%20bag%20in%20beige%20with%20adjustable%20strap%20and%20multiple%20pockets%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20practical%20fashion%20accessory&width=600&height=600&seq=crossbody-phone-bag&orientation=squarish',
    commission: 5.69,
    recurring: false,
  },
  {
    id: 165,
    name: 'Hair Claw Clips Set - 6 Pieces',
    price: 11.99,
    category: 'Fashion',
    description: 'Trendy hair claw clips in various sizes and colors',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20hair%20claw%20clips%20in%20different%20sizes%20arranged%20artistically%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20trendy%20hair%20accessories&width=600&height=600&seq=hair-claw-clips-set&orientation=squarish',
    commission: 3.59,
    recurring: false,
  },
  {
    id: 166,
    name: 'Bluetooth Mini Speaker',
    price: 22.99,
    category: 'Electronics',
    description: 'Portable waterproof speaker with 360-degree sound',
    image: 'https://readdy.ai/api/search-image?query=compact%20bluetooth%20speaker%20in%20vibrant%20teal%20color%20with%20modern%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20portable%20audio%20device&width=600&height=600&seq=bluetooth-mini-speaker&orientation=squarish',
    commission: 6.89,
    recurring: false,
  },
  {
    id: 167,
    name: 'Phone Ring Holder - Pop Socket',
    price: 7.99,
    category: 'Electronics',
    description: 'Collapsible phone grip with kickstand function',
    image: 'https://readdy.ai/api/search-image?query=modern%20phone%20ring%20holder%20pop%20socket%20in%20rose%20gold%20with%20collapsible%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20practical%20phone%20accessory&width=600&height=600&seq=phone-ring-holder&orientation=squarish',
    commission: 2.39,
    recurring: false,
  },
  {
    id: 168,
    name: 'USB-C Fast Charging Cable - 3 Pack',
    price: 13.99,
    category: 'Electronics',
    description: 'Durable braided charging cables in 3ft, 6ft, 10ft lengths',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20three%20braided%20USB-C%20charging%20cables%20in%20different%20lengths%20with%20premium%20connectors%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20quality%20tech%20accessories&width=600&height=600&seq=usbc-cable-pack&orientation=squarish',
    commission: 4.19,
    recurring: false,
  },
  {
    id: 169,
    name: 'Jade Roller & Gua Sha Set',
    price: 14.99,
    category: 'Health & Beauty',
    description: 'Natural jade facial massage tools for skincare routine',
    image: 'https://readdy.ai/api/search-image?query=elegant%20jade%20roller%20and%20gua%20sha%20stone%20in%20natural%20green%20jade%20displayed%20in%20gift%20box%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20beauty%20wellness%20tools&width=600&height=600&seq=jade-roller-guasha&orientation=squarish',
    commission: 4.49,
    recurring: false,
  },
  {
    id: 170,
    name: 'Sheet Mask Set - 20 Pack',
    price: 16.99,
    category: 'Health & Beauty',
    description: 'Variety pack of hydrating facial sheet masks',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20sheet%20mask%20packets%20in%20various%20formulas%20arranged%20neatly%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20skincare%20beauty%20products&width=600&height=600&seq=sheet-mask-set&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 171,
    name: 'Resistance Bands Set - 5 Levels',
    price: 16.99,
    category: 'Health & Fitness',
    description: 'Exercise resistance bands with handles and door anchor',
    image: 'https://readdy.ai/api/search-image?query=colorful%20resistance%20bands%20in%20five%20different%20strengths%20with%20handles%20and%20accessories%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20fitness%20equipment&width=600&height=600&seq=resistance-bands-5level&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 172,
    name: 'Insulated Water Bottle - 32oz',
    price: 24.99,
    category: 'Home & Living',
    description: 'Stainless steel water bottle keeps drinks cold for 24 hours',
    image: 'https://readdy.ai/api/search-image?query=sleek%20stainless%20steel%20water%20bottle%20in%20matte%20teal%20with%20wide%20mouth%20opening%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20modern%20hydration%20bottle&width=600&height=600&seq=insulated-water-bottle&orientation=squarish',
    commission: 7.49,
    recurring: false,
  },
  {
    id: 173,
    name: 'Throw Pillow Covers - 4 Pack',
    price: 16.99,
    category: 'Home & Living',
    description: 'Decorative pillow covers in modern geometric patterns',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20four%20decorative%20throw%20pillow%20covers%20in%20neutral%20tones%20with%20geometric%20patterns%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20home%20decor%20textiles&width=600&height=600&seq=throw-pillow-covers&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 174,
    name: 'Desk Organizer Set',
    price: 19.99,
    category: 'Home & Living',
    description: 'Bamboo desk organizer with multiple compartments',
    image: 'https://readdy.ai/api/search-image?query=elegant%20bamboo%20desk%20organizer%20with%20multiple%20compartments%20for%20pens%20pencils%20and%20office%20supplies%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20workspace%20organization&width=600&height=600&seq=desk-organizer-bamboo&orientation=squarish',
    commission: 5.99,
    recurring: false,
  },
  {
    id: 175,
    name: 'Ceramic Plant Pots - 3 Pack',
    price: 17.99,
    category: 'Home & Living',
    description: 'Modern ceramic planters with drainage holes and saucers',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20three%20modern%20ceramic%20plant%20pots%20in%20white%20with%20minimalist%20design%20and%20drainage%20saucers%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20home%20garden%20decor&width=600&height=600&seq=ceramic-plant-pots&orientation=squarish',
    commission: 5.39,
    recurring: false,
  },
  {
    id: 176,
    name: 'LED Candles - 12 Pack',
    price: 18.99,
    category: 'Home & Living',
    description: 'Flameless LED tea light candles with remote control',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20flameless%20LED%20candles%20with%20realistic%20flickering%20light%20and%20remote%20control%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20ambient%20home%20lighting&width=600&height=600&seq=led-candles-pack&orientation=squarish',
    commission: 5.69,
    recurring: false,
  },
  {
    id: 177,
    name: 'Shower Caddy - Rust Proof',
    price: 21.99,
    category: 'Home & Living',
    description: 'Stainless steel shower organizer with adjustable shelves',
    image: 'https://readdy.ai/api/search-image?query=modern%20stainless%20steel%20shower%20caddy%20with%20multiple%20shelves%20and%20hooks%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20bathroom%20organization%20solution&width=600&height=600&seq=shower-caddy-rustproof&orientation=squarish',
    commission: 6.59,
    recurring: false,
  },
  {
    id: 178,
    name: 'Coffee Mug Set - 4 Unique Designs',
    price: 24.99,
    category: 'Home & Living',
    description: 'Ceramic coffee mugs with inspirational quotes',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20four%20ceramic%20coffee%20mugs%20with%20modern%20designs%20and%20inspirational%20quotes%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20kitchen%20drinkware&width=600&height=600&seq=coffee-mug-set&orientation=squarish',
    commission: 7.49,
    recurring: false,
  },
  {
    id: 179,
    name: 'Silicone Baking Mat Set - 3 Pack',
    price: 14.99,
    category: 'Kitchen & Dining',
    description: 'Heat-resistant silicone baking mats for oven and microwave',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20three%20silicone%20baking%20mats%20in%20neutral%20colors%20with%20measurement%20markings%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20kitchen%20baking%20accessories&width=600&height=600&seq=silicone-baking-mats&orientation=squarish',
    commission: 4.49,
    recurring: false,
  },
  {
    id: 180,
    name: 'Reusable Food Storage Bags - 10 Pack',
    price: 17.99,
    category: 'Kitchen & Dining',
    description: 'Eco-friendly silicone food bags in various sizes',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20reusable%20silicone%20food%20storage%20bags%20in%20different%20sizes%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20eco%20friendly%20kitchen%20products&width=600&height=600&seq=reusable-food-bags&orientation=squarish',
    commission: 5.39,
    recurring: false,
  },
  {
    id: 181,
    name: 'Herb Scissors - 5 Blade',
    price: 9.99,
    category: 'Kitchen & Dining',
    description: 'Multi-blade herb scissors with cleaning comb',
    image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20herb%20scissors%20with%20five%20blades%20and%20cleaning%20comb%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20kitchen%20cutting%20tool&width=600&height=600&seq=herb-scissors-5blade&orientation=squarish',
    commission: 2.99,
    recurring: false,
  },
  {
    id: 182,
    name: 'Avocado Slicer Tool',
    price: 8.99,
    category: 'Kitchen & Dining',
    description: '3-in-1 avocado tool: split, pit, slice',
    image: 'https://readdy.ai/api/search-image?query=green%20avocado%20slicer%20tool%20with%20multiple%20functions%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20practical%20kitchen%20gadget&width=600&height=600&seq=avocado-slicer-tool&orientation=squarish',
    commission: 2.69,
    recurring: false,
  },
  {
    id: 183,
    name: 'Measuring Spoon Set - Magnetic',
    price: 12.99,
    category: 'Kitchen & Dining',
    description: 'Stainless steel measuring spoons with magnetic storage',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20stainless%20steel%20measuring%20spoons%20with%20magnetic%20nesting%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20kitchen%20measuring%20tools&width=600&height=600&seq=measuring-spoon-magnetic&orientation=squarish',
    commission: 3.89,
    recurring: false,
  },
  {
    id: 184,
    name: 'Silicone Spatula Set - 5 Pieces',
    price: 15.99,
    category: 'Kitchen & Dining',
    description: 'Heat-resistant silicone spatulas in various shapes',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20five%20colorful%20silicone%20spatulas%20in%20different%20shapes%20with%20wooden%20handles%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20kitchen%20utensils&width=600&height=600&seq=silicone-spatula-set&orientation=squarish',
    commission: 4.79,
    recurring: false,
  },
  {
    id: 185,
    name: 'Handheld Coffee Frother',
    price: 13.99,
    category: 'Kitchen & Dining',
    description: 'Electric milk frother for coffee and lattes',
    image: 'https://readdy.ai/api/search-image?query=sleek%20handheld%20electric%20milk%20frother%20in%20stainless%20steel%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20coffee%20making%20tool&width=600&height=600&seq=coffee-frother-handheld&orientation=squarish',
    commission: 4.19,
    recurring: false,
  },
  {
    id: 186,
    name: 'Tea Infuser Set - 2 Pack',
    price: 11.99,
    category: 'Kitchen & Dining',
    description: 'Stainless steel tea infusers with drip trays',
    image: 'https://readdy.ai/api/search-image?query=elegant%20stainless%20steel%20tea%20infusers%20with%20mesh%20design%20and%20drip%20trays%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20tea%20brewing%20accessories&width=600&height=600&seq=tea-infuser-set&orientation=squarish',
    commission: 3.59,
    recurring: false,
  },
  {
    id: 187,
    name: 'Spice Jar Set - 24 Bottles',
    price: 29.99,
    category: 'Kitchen & Dining',
    description: 'Glass spice jars with labels and shaker lids',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20glass%20spice%20jars%20with%20black%20lids%20and%20labels%20arranged%20neatly%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20kitchen%20organization&width=600&height=600&seq=spice-jar-set-24&orientation=squarish',
    commission: 8.99,
    recurring: false,
  },
  {
    id: 188,
    name: 'Bamboo Utensil Set',
    price: 18.99,
    category: 'Kitchen & Dining',
    description: 'Eco-friendly bamboo cooking utensils - 6 pieces',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20bamboo%20cooking%20utensils%20including%20spoons%20spatulas%20and%20turner%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20eco%20friendly%20kitchen%20tools&width=600&height=600&seq=bamboo-utensil-set&orientation=squarish',
    commission: 5.69,
    recurring: false,
  },
  {
    id: 189,
    name: 'Drawer Organizer Set - 6 Pieces',
    price: 16.99,
    category: 'Home & Living',
    description: 'Adjustable drawer dividers for closet organization',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20white%20drawer%20organizer%20dividers%20in%20various%20sizes%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20home%20organization%20solution&width=600&height=600&seq=drawer-organizer-6piece&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 190,
    name: 'Wall Hooks - Decorative 6 Pack',
    price: 14.99,
    category: 'Home & Living',
    description: 'Modern wall hooks in gold finish for coats and bags',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20six%20modern%20wall%20hooks%20in%20gold%20finish%20with%20elegant%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20home%20hardware%20accessories&width=600&height=600&seq=wall-hooks-decorative&orientation=squarish',
    commission: 4.49,
    recurring: false,
  },
  {
    id: 191,
    name: 'Coaster Set - 8 Pieces with Holder',
    price: 12.99,
    category: 'Home & Living',
    description: 'Absorbent stone coasters with metal holder',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20eight%20stone%20coasters%20in%20neutral%20colors%20with%20metal%20holder%20stand%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20table%20accessories&width=600&height=600&seq=coaster-set-8piece&orientation=squarish',
    commission: 3.89,
    recurring: false,
  },
  {
    id: 192,
    name: 'Picture Frame Set - 7 Frames',
    price: 24.99,
    category: 'Home & Living',
    description: 'Gallery wall frame set in various sizes',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20seven%20picture%20frames%20in%20black%20with%20various%20sizes%20arranged%20artistically%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20wall%20decor&width=600&height=600&seq=picture-frame-set&orientation=squarish',
    commission: 7.49,
    recurring: false,
  },
  {
    id: 193,
    name: 'Hair Towel Wrap - Microfiber',
    price: 11.99,
    category: 'Health & Beauty',
    description: 'Quick-dry hair towel with button closure',
    image: 'https://readdy.ai/api/search-image?query=soft%20microfiber%20hair%20towel%20wrap%20in%20pastel%20pink%20with%20button%20closure%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20hair%20care%20accessory&width=600&height=600&seq=hair-towel-wrap&orientation=squarish',
    commission: 3.59,
    recurring: false,
  },
  {
    id: 194,
    name: 'Makeup Sponge Set - 8 Pack',
    price: 12.99,
    category: 'Health & Beauty',
    description: 'Latex-free beauty blender sponges in various shapes',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20makeup%20sponges%20in%20different%20shapes%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20beauty%20application%20tools&width=600&height=600&seq=makeup-sponge-set&orientation=squarish',
    commission: 3.89,
    recurring: false,
  },
  {
    id: 195,
    name: 'Nail Care Kit - 18 Pieces',
    price: 16.99,
    category: 'Health & Beauty',
    description: 'Professional manicure and pedicure tool set',
    image: 'https://readdy.ai/api/search-image?query=professional%20nail%20care%20kit%20with%20stainless%20steel%20tools%20in%20leather%20case%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20beauty%20grooming%20set&width=600&height=600&seq=nail-care-kit&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 196,
    name: 'Facial Cleansing Brush',
    price: 19.99,
    category: 'Health & Beauty',
    description: 'Electric facial brush with 3 speed settings',
    image: 'https://readdy.ai/api/search-image?query=modern%20electric%20facial%20cleansing%20brush%20in%20soft%20pink%20with%20brush%20heads%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20skincare%20device&width=600&height=600&seq=facial-cleansing-brush&orientation=squarish',
    commission: 5.99,
    recurring: false,
  },
  {
    id: 197,
    name: 'Travel Toiletry Bottles - TSA Approved',
    price: 9.99,
    category: 'Health & Beauty',
    description: 'Leak-proof silicone travel bottles set of 8',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20colorful%20silicone%20travel%20bottles%20in%20TSA%20approved%20sizes%20with%20labels%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20travel%20accessories&width=600&height=600&seq=travel-toiletry-bottles&orientation=squarish',
    commission: 2.99,
    recurring: false,
  },
  {
    id: 198,
    name: 'Yoga Block Set - 2 Blocks',
    price: 15.99,
    category: 'Health & Fitness',
    description: 'High-density foam yoga blocks for support',
    image: 'https://readdy.ai/api/search-image?query=pair%20of%20yoga%20blocks%20in%20teal%20color%20with%20non%20slip%20surface%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20fitness%20yoga%20accessories&width=600&height=600&seq=yoga-block-set&orientation=squarish',
    commission: 4.79,
    recurring: false,
  },
  {
    id: 199,
    name: 'Cable Organizer Set - 10 Pieces',
    price: 11.99,
    category: 'Electronics',
    description: 'Cable management clips and ties for desk organization',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20cable%20organizers%20clips%20and%20ties%20in%20black%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20tech%20organization%20accessories&width=600&height=600&seq=cable-organizer-set&orientation=squarish',
    commission: 3.59,
    recurring: false,
  },
  {
    id: 200,
    name: 'Phone Camera Lens Kit - 3 Lenses',
    price: 17.99,
    category: 'Electronics',
    description: 'Clip-on wide angle, macro, and fisheye lenses',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20three%20clip-on%20phone%20camera%20lenses%20with%20case%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20mobile%20photography%20accessories&width=600&height=600&seq=phone-camera-lens-kit&orientation=squarish',
    commission: 5.39,
    recurring: false,
  },
  {
    id: 201,
    name: 'Screen Protector - 3 Pack',
    price: 11.99,
    category: 'Electronics',
    description: 'Tempered glass screen protectors with installation kit',
    image: 'https://readdy.ai/api/search-image?query=tempered%20glass%20screen%20protectors%20in%20packaging%20with%20installation%20tools%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20phone%20protection%20accessories&width=600&height=600&seq=screen-protector-3pack&orientation=squarish',
    commission: 3.59,
    recurring: false,
  },
  {
    id: 202,
    name: 'Scrunchie Set - 20 Pack',
    price: 10.99,
    category: 'Fashion',
    description: 'Velvet hair scrunchies in assorted colors',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20velvet%20scrunchies%20in%20various%20colors%20arranged%20artistically%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20hair%20accessories&width=600&height=600&seq=scrunchie-set-20pack&orientation=squarish',
    commission: 3.29,
    recurring: false,
  },
  {
    id: 203,
    name: 'Trendy Sunglasses - UV Protection',
    price: 16.99,
    category: 'Fashion',
    description: 'Fashion sunglasses with polarized lenses',
    image: 'https://readdy.ai/api/search-image?query=stylish%20modern%20sunglasses%20with%20dark%20lenses%20and%20trendy%20frame%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20fashion%20eyewear&width=600&height=600&seq=trendy-sunglasses-uv&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 204,
    name: 'Baseball Cap - Adjustable',
    price: 14.99,
    category: 'Fashion',
    description: 'Classic baseball cap in premium cotton',
    image: 'https://readdy.ai/api/search-image?query=premium%20quality%20baseball%20cap%20in%20classic%20black%20color%20with%20curved%20brim%20and%20adjustable%20back%20strap%20showing%20detailed%20stitching%20and%20embroidered%20logo%20on%20front%20panel%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20highlighting%20the%20fabric%20texture%20and%20modern%20sporty%20design%20perfect%20for%20casual%20everyday%20wear&width=600&height=600&seq=baseball-cap-premium-v2&orientation=squarish',
    commission: 4.49,
    recurring: false,
  },
  {
    id: 205,
    name: 'Canvas Tote Bag',
    price: 15.99,
    category: 'Fashion',
    description: 'Eco-friendly canvas tote with inner pocket',
    image: 'https://readdy.ai/api/search-image?query=natural%20canvas%20tote%20bag%20with%20minimalist%20design%20and%20inner%20pocket%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20eco%20friendly%20shopping%20bag&width=600&height=600&seq=canvas-tote-bag&orientation=squarish',
    commission: 4.79,
    recurring: false,
  },
  {
    id: 206,
    name: 'Ankle Socks - 10 Pairs',
    price: 14.99,
    category: 'Fashion',
    description: 'Comfortable cotton ankle socks in neutral colors',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20ankle%20socks%20in%20neutral%20colors%20neatly%20arranged%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20everyday%20clothing%20essentials&width=600&height=600&seq=ankle-socks-10pair&orientation=squarish',
    commission: 4.49,
    recurring: false,
  },
  {
    id: 207,
    name: 'Statement Earrings - 3 Pairs',
    price: 16.99,
    category: 'Fashion',
    description: 'Trendy geometric earrings in gold tone',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20three%20pairs%20of%20modern%20geometric%20earrings%20in%20gold%20finish%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20fashion%20jewelry&width=600&height=600&seq=statement-earrings-3pair&orientation=squarish',
    commission: 5.09,
    recurring: false,
  },
  {
    id: 208,
    name: 'Minimalist Necklace',
    price: 18.99,
    category: 'Fashion',
    description: 'Delicate layered necklace in gold or silver',
    image: 'https://readdy.ai/api/search-image?query=elegant%20minimalist%20layered%20necklace%20in%20gold%20with%20delicate%20chains%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20dainty%20jewelry&width=600&height=600&seq=minimalist-necklace&orientation=squarish',
    commission: 5.69,
    recurring: false,
  },
  
  // ========== ELECTRONICS (30+ more products) ==========
  {
    id: 7,
    name: 'iPhone 15 Pro Max - 512GB',
    price: 1399.99,
    category: 'Electronics',
    description: 'Latest flagship smartphone with titanium design and advanced camera system',
    image: 'https://readdy.ai/api/search-image?query=premium%20smartphone%20with%20sleek%20titanium%20frame%20and%20edge%20to%20edge%20display%20showing%20elegant%20interface%20on%20clean%20white%20surface%20with%20soft%20professional%20studio%20lighting%20highlighting%20the%20modern%20design&width=600&height=600&seq=phone1&orientation=squarish',
    commission: 419.99,
    recurring: false,
  },
  {
    id: 8,
    name: '4K Smart TV - 75 Inch OLED',
    price: 2299.99,
    category: 'Electronics',
    description: 'Ultra-premium OLED television with Dolby Vision and smart home integration',
    image: 'https://readdy.ai/api/search-image?query=large%20modern%20smart%20television%20with%20ultra%20thin%20bezels%20displaying%20vibrant%20colorful%20nature%20scene%20on%20screen%20mounted%20on%20clean%20white%20wall%20in%20minimalist%20living%20room%20with%20professional%20lighting&width=600&height=600&seq=tv1&orientation=squarish',
    commission: 689.99,
    recurring: false,
  },
  {
    id: 9,
    name: 'Wireless Noise-Cancelling Headphones',
    price: 399.99,
    category: 'Electronics',
    description: 'Premium over-ear headphones with active noise cancellation and 30-hour battery',
    image: 'https://readdy.ai/api/search-image?query=premium%20wireless%20headphones%20with%20sleek%20modern%20design%20and%20cushioned%20ear%20cups%20displayed%20on%20clean%20white%20surface%20showing%20the%20elegant%20curves%20and%20professional%20build%20quality%20with%20soft%20studio%20lighting&width=600&height=600&seq=headphones1&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 10,
    name: 'Gaming Laptop - RTX 4080',
    price: 2199.99,
    category: 'Electronics',
    description: 'High-performance gaming laptop with RGB keyboard and 240Hz display',
    image: 'https://readdy.ai/api/search-image?query=powerful%20gaming%20laptop%20with%20illuminated%20keyboard%20and%20high%20refresh%20rate%20display%20showing%20gaming%20interface%20on%20screen%20placed%20on%20clean%20white%20desk%20in%20modern%20setup%20with%20professional%20lighting&width=600&height=600&seq=gaminglaptop1&orientation=squarish',
    commission: 659.99,
    recurring: false,
  },
  {
    id: 41,
    name: 'iPad Pro 12.9" - 1TB with Apple Pencil',
    price: 1799.99,
    category: 'Electronics',
    description: 'Ultimate creative tablet with M2 chip, ProMotion display, and professional accessories',
    image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20tablet%20computer%20with%20large%20display%20and%20stylus%20pen%20on%20pristine%20white%20desk%20showing%20creative%20design%20app%20interface%20with%20professional%20studio%20lighting%20and%20minimalist%20aesthetic&width=600&height=600&seq=ipad-pro-new&orientation=squarish',
    commission: 539.99,
    recurring: false,
  },
  {
    id: 42,
    name: 'Sony PlayStation 5 Pro Bundle',
    price: 699.99,
    category: 'Electronics',
    description: 'Next-gen gaming console with 2TB storage, extra controller, and 3 AAA games',
    image: 'https://readdy.ai/api/search-image?query=modern%20white%20gaming%20console%20with%20sleek%20futuristic%20design%20and%20wireless%20controller%20displayed%20on%20clean%20white%20surface%20with%20soft%20blue%20accent%20lighting%20in%20professional%20studio%20setup&width=600&height=600&seq=ps5-bundle-new&orientation=squarish',
    commission: 209.99,
    recurring: false,
  },
  {
    id: 43,
    name: 'DJI Mavic 3 Pro Drone',
    price: 2199.99,
    category: 'Electronics',
    description: 'Professional aerial photography drone with 4K camera and 45-minute flight time',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20professional%20drone%20with%20multiple%20propellers%20and%20high%20quality%20camera%20gimbal%20displayed%20on%20clean%20white%20surface%20showing%20sleek%20gray%20design%20with%20professional%20studio%20lighting&width=600&height=600&seq=drone-mavic-new&orientation=squarish',
    commission: 659.99,
    recurring: false,
  },
  {
    id: 44,
    name: 'Samsung Galaxy Watch Ultra',
    price: 649.99,
    category: 'Electronics',
    description: 'Premium smartwatch with health monitoring, GPS, and 3-day battery life',
    image: 'https://readdy.ai/api/search-image?query=elegant%20premium%20smartwatch%20with%20circular%20display%20and%20titanium%20band%20showing%20fitness%20metrics%20on%20screen%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=galaxy-watch-new&orientation=squarish',
    commission: 194.99,
    recurring: false,
  },
  {
    id: 45,
    name: 'Bose SoundLink Revolve+ Speaker',
    price: 329.99,
    category: 'Electronics',
    description: 'Portable Bluetooth speaker with 360-degree sound and 16-hour battery',
    image: 'https://readdy.ai/api/search-image?query=cylindrical%20portable%20bluetooth%20speaker%20in%20sleek%20black%20finish%20with%20premium%20metal%20grille%20displayed%20on%20pristine%20white%20surface%20with%20soft%20professional%20lighting%20showing%20modern%20minimalist%20design&width=600&height=600&seq=bose-speaker-new&orientation=squarish',
    commission: 98.99,
    recurring: false,
  },
  {
    id: 46,
    name: 'Kindle Oasis E-Reader - 32GB',
    price: 349.99,
    category: 'Electronics',
    description: 'Premium e-reader with 7-inch display, adjustable warm light, and waterproof design',
    image: 'https://readdy.ai/api/search-image?query=elegant%20e-reader%20device%20with%20high%20resolution%20display%20showing%20book%20page%20on%20screen%20with%20sleek%20aluminum%20body%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=kindle-oasis-new&orientation=squarish',
    commission: 104.99,
    recurring: false,
  },
  {
    id: 47,
    name: 'GoPro HERO 12 Black Action Camera',
    price: 499.99,
    category: 'Electronics',
    description: 'Waterproof action camera with 5.3K video, HyperSmooth stabilization',
    image: 'https://readdy.ai/api/search-image?query=compact%20rugged%20action%20camera%20in%20black%20with%20protective%20housing%20and%20mounting%20accessories%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20durable%20design&width=600&height=600&seq=gopro-hero-new&orientation=squarish',
    commission: 149.99,
    recurring: false,
  },
  {
    id: 48,
    name: 'Logitech MX Master 3S Wireless Mouse',
    price: 99.99,
    category: 'Electronics',
    description: 'Ergonomic wireless mouse with precision scrolling and multi-device connectivity',
    image: 'https://readdy.ai/api/search-image?query=premium%20ergonomic%20wireless%20computer%20mouse%20in%20dark%20gray%20with%20smooth%20curves%20and%20precision%20scroll%20wheel%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=logitech-mouse-new&orientation=squarish',
    commission: 29.99,
    recurring: false,
  },
  {
    id: 49,
    name: 'Ring Video Doorbell Pro 2',
    price: 249.99,
    category: 'Electronics',
    description: 'Smart doorbell with 1536p HD video, 3D motion detection, and two-way talk',
    image: 'https://readdy.ai/api/search-image?query=modern%20smart%20video%20doorbell%20with%20sleek%20black%20design%20and%20camera%20lens%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20build%20quality&width=600&height=600&seq=ring-doorbell-new&orientation=squarish',
    commission: 74.99,
    recurring: false,
  },
  {
    id: 50,
    name: 'Anker PowerCore 26800mAh Power Bank',
    price: 79.99,
    category: 'Electronics',
    description: 'Ultra-high capacity portable charger with fast charging for multiple devices',
    image: 'https://readdy.ai/api/search-image?query=sleek%20portable%20battery%20charger%20in%20matte%20black%20finish%20with%20multiple%20USB%20ports%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20compact%20modern%20design&width=600&height=600&seq=anker-powerbank-new&orientation=squarish',
    commission: 23.99,
    recurring: false,
  },
  {
    id: 51,
    name: 'Razer BlackWidow V4 Gaming Keyboard',
    price: 229.99,
    category: 'Electronics',
    description: 'Mechanical gaming keyboard with RGB lighting and programmable keys',
    image: 'https://readdy.ai/api/search-image?query=premium%20mechanical%20gaming%20keyboard%20with%20colorful%20RGB%20backlighting%20and%20sleek%20black%20design%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20modern%20gaming%20aesthetic&width=600&height=600&seq=razer-keyboard-new&orientation=squarish',
    commission: 68.99,
    recurring: false,
  },
  {
    id: 103,
    name: 'Microsoft Surface Pro 9 - 16GB RAM',
    price: 1599.99,
    category: 'Electronics',
    description: '2-in-1 laptop tablet with Intel i7, Type Cover keyboard, and Surface Pen',
    image: 'https://readdy.ai/api/search-image?query=sleek%20modern%202-in-1%20laptop%20tablet%20device%20with%20detachable%20keyboard%20and%20stylus%20pen%20displayed%20on%20pristine%20white%20surface%20showing%20versatile%20design%20with%20professional%20studio%20lighting&width=600&height=600&seq=surface-pro-9-new&orientation=squarish',
    commission: 479.99,
    recurring: false,
  },
  {
    id: 104,
    name: 'Sonos Arc Soundbar - Dolby Atmos',
    price: 899.99,
    category: 'Electronics',
    description: 'Premium soundbar with 3D audio, voice control, and seamless streaming',
    image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20soundbar%20in%20matte%20black%20with%20premium%20fabric%20grille%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20sleek%20minimalist%20design&width=600&height=600&seq=sonos-arc-new&orientation=squarish',
    commission: 269.99,
    recurring: false,
  },
  {
    id: 105,
    name: 'Canon EOS R6 Mark II Camera Body',
    price: 2499.99,
    category: 'Electronics',
    description: 'Professional mirrorless camera with 24MP sensor and 40fps burst shooting',
    image: 'https://readdy.ai/api/search-image?query=professional%20mirrorless%20camera%20body%20in%20black%20with%20advanced%20controls%20and%20viewfinder%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20build%20quality&width=600&height=600&seq=canon-r6-mark2-new&orientation=squarish',
    commission: 749.99,
    recurring: false,
  },
  {
    id: 106,
    name: 'Nest Learning Thermostat - 3rd Gen',
    price: 249.99,
    category: 'Electronics',
    description: 'Smart thermostat that learns your schedule and saves energy automatically',
    image: 'https://readdy.ai/api/search-image?query=modern%20circular%20smart%20thermostat%20with%20sleek%20metal%20ring%20and%20digital%20display%20mounted%20on%20pristine%20white%20wall%20with%20professional%20studio%20lighting%20showing%20elegant%20design&width=600&height=600&seq=nest-thermostat-new&orientation=squarish',
    commission: 74.99,
    recurring: false,
  },
  {
    id: 107,
    name: 'Oculus Quest 3 VR Headset - 512GB',
    price: 649.99,
    category: 'Electronics',
    description: 'Next-gen virtual reality headset with mixed reality and wireless freedom',
    image: 'https://readdy.ai/api/search-image?query=modern%20VR%20headset%20with%20sleek%20white%20design%20and%20adjustable%20straps%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20futuristic%20technology&width=600&height=600&seq=oculus-quest3-new&orientation=squarish',
    commission: 194.99,
    recurring: false,
  },
  {
    id: 108,
    name: 'Dyson V15 Detect Cordless Vacuum',
    price: 749.99,
    category: 'Electronics',
    description: 'Intelligent cordless vacuum with laser detection and LCD screen',
    image: 'https://readdy.ai/api/search-image?query=modern%20cordless%20stick%20vacuum%20cleaner%20in%20sleek%20design%20with%20digital%20display%20and%20multiple%20attachments%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=dyson-v15-new&orientation=squarish',
    commission: 224.99,
    recurring: false,
  },
  {
    id: 109,
    name: 'Apple AirPods Pro 2nd Generation',
    price: 249.99,
    category: 'Electronics',
    description: 'Premium wireless earbuds with active noise cancellation and spatial audio',
    image: 'https://readdy.ai/api/search-image?query=premium%20wireless%20earbuds%20in%20white%20charging%20case%20with%20sleek%20minimalist%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20modern%20technology&width=600&height=600&seq=airpods-pro2-new&orientation=squarish',
    commission: 74.99,
    recurring: false,
  },
  {
    id: 110,
    name: 'Samsung Galaxy S24 Ultra - 256GB',
    price: 1299.99,
    category: 'Electronics',
    description: 'Flagship Android phone with S Pen, 200MP camera, and titanium frame',
    image: 'https://readdy.ai/api/search-image?query=premium%20flagship%20smartphone%20with%20large%20display%20and%20stylus%20pen%20in%20elegant%20titanium%20finish%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=galaxy-s24-ultra-new&orientation=squarish',
    commission: 389.99,
    recurring: false,
  },
  {
    id: 111,
    name: 'Arlo Pro 5 Security Camera System',
    price: 599.99,
    category: 'Electronics',
    description: '4-camera wireless security system with 2K HDR video and color night vision',
    image: 'https://readdy.ai/api/search-image?query=modern%20wireless%20security%20camera%20in%20white%20with%20sleek%20design%20and%20mounting%20bracket%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20smart%20home%20technology&width=600&height=600&seq=arlo-pro5-new&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
  {
    id: 112,
    name: 'LG UltraGear 27" Gaming Monitor',
    price: 799.99,
    category: 'Electronics',
    description: '4K 144Hz gaming monitor with NVIDIA G-SYNC and HDR10',
    image: 'https://readdy.ai/api/search-image?query=modern%20gaming%20monitor%20with%20thin%20bezels%20displaying%20vibrant%20colorful%20gaming%20scene%20on%20large%20screen%20with%20sleek%20stand%20on%20pristine%20white%20surface%20with%20professional%20lighting&width=600&height=600&seq=lg-ultragear-new&orientation=squarish',
    commission: 239.99,
    recurring: false,
  },
  {
    id: 113,
    name: 'Philips Hue Smart Lighting Starter Kit',
    price: 199.99,
    category: 'Electronics',
    description: 'Color-changing smart bulbs with bridge, voice control, and app integration',
    image: 'https://readdy.ai/api/search-image?query=smart%20LED%20light%20bulbs%20with%20hub%20device%20displaying%20colorful%20lighting%20options%20arranged%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20smart%20home%20technology&width=600&height=600&seq=philips-hue-new&orientation=squarish',
    commission: 59.99,
    recurring: false,
  },

  // ========== FASHION (25+ more products) ==========
  {
    id: 11,
    name: 'Designer Leather Handbag',
    price: 1299.99,
    category: 'Fashion',
    description: 'Luxury Italian leather handbag with gold hardware and signature design',
    image: 'https://readdy.ai/api/search-image?query=elegant%20designer%20leather%20handbag%20in%20rich%20brown%20color%20with%20gold%20metal%20hardware%20and%20sophisticated%20stitching%20displayed%20on%20pristine%20white%20surface%20with%20soft%20professional%20studio%20lighting&width=600&height=600&seq=handbag1&orientation=squarish',
    commission: 389.99,
    recurring: false,
  },
  {
    id: 12,
    name: 'Premium Cashmere Coat',
    price: 899.99,
    category: 'Fashion',
    description: 'Luxurious 100% cashmere winter coat with tailored fit and elegant design',
    image: 'https://readdy.ai/api/search-image?query=elegant%20cashmere%20winter%20coat%20in%20neutral%20beige%20color%20with%20refined%20tailoring%20and%20sophisticated%20design%20displayed%20on%20clean%20white%20background%20with%20professional%20studio%20lighting%20showing%20the%20premium%20fabric%20texture&width=600&height=600&seq=coat1&orientation=squarish',
    commission: 269.99,
    recurring: false,
  },
  {
    id: 13,
    name: 'Designer Sunglasses Collection',
    price: 449.99,
    category: 'Fashion',
    description: 'Premium polarized sunglasses with UV protection and iconic design',
    image: 'https://readdy.ai/api/search-image?query=stylish%20designer%20sunglasses%20with%20dark%20lenses%20and%20elegant%20frame%20design%20displayed%20on%20clean%20white%20surface%20with%20soft%20professional%20lighting%20highlighting%20the%20premium%20craftsmanship&width=600&height=600&seq=sunglasses1&orientation=squarish',
    commission: 134.99,
    recurring: false,
  },
  {
    id: 14,
    name: 'Luxury Sneaker Collection',
    price: 599.99,
    category: 'Fashion',
    description: 'Limited edition designer sneakers with premium materials and exclusive colorway',
    image: 'https://readdy.ai/api/search-image?query=premium%20designer%20sneakers%20with%20clean%20white%20leather%20and%20elegant%20design%20details%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20the%20craftsmanship%20and%20modern%20style&width=600&height=600&seq=sneakers1&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
  {
    id: 52,
    name: 'Silk Evening Gown - Designer Collection',
    price: 1599.99,
    category: 'Fashion',
    description: 'Elegant floor-length silk gown with intricate beading and couture craftsmanship',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20flowing%20silk%20evening%20gown%20in%20deep%20emerald%20green%20with%20elegant%20draping%20and%20sophisticated%20silhouette%20displayed%20on%20dress%20form%20against%20pristine%20white%20background%20with%20soft%20professional%20lighting&width=600&height=600&seq=evening-gown-new&orientation=squarish',
    commission: 479.99,
    recurring: false,
  },
  {
    id: 53,
    name: 'Italian Leather Boots - Handcrafted',
    price: 749.99,
    category: 'Fashion',
    description: 'Premium knee-high leather boots with artisan craftsmanship and timeless style',
    image: 'https://readdy.ai/api/search-image?query=elegant%20knee%20high%20leather%20boots%20in%20rich%20cognac%20brown%20with%20smooth%20finish%20and%20refined%20stitching%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20quality&width=600&height=600&seq=leather-boots-new&orientation=squarish',
    commission: 224.99,
    recurring: false,
  },
  {
    id: 54,
    name: 'Cashmere Scarf - Luxury Collection',
    price: 299.99,
    category: 'Fashion',
    description: 'Ultra-soft cashmere scarf in classic pattern with hand-rolled edges',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20cashmere%20scarf%20in%20elegant%20plaid%20pattern%20with%20soft%20texture%20beautifully%20draped%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20the%20premium%20fabric%20quality&width=600&height=600&seq=cashmere-scarf-new&orientation=squarish',
    commission: 89.99,
    recurring: false,
  },
  {
    id: 55,
    name: 'Designer Denim Jacket - Premium Wash',
    price: 449.99,
    category: 'Fashion',
    description: 'Vintage-inspired denim jacket with custom distressing and perfect fit',
    image: 'https://readdy.ai/api/search-image?query=stylish%20denim%20jacket%20in%20medium%20blue%20wash%20with%20classic%20design%20and%20modern%20fit%20displayed%20on%20clean%20white%20background%20with%20professional%20studio%20lighting%20showing%20the%20premium%20denim%20quality&width=600&height=600&seq=denim-jacket-new&orientation=squarish',
    commission: 134.99,
    recurring: false,
  },
  {
    id: 56,
    name: 'Silk Tie Collection - 5 Piece Set',
    price: 349.99,
    category: 'Fashion',
    description: 'Handmade silk ties in sophisticated patterns for the modern professional',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20elegant%20silk%20neckties%20in%20various%20sophisticated%20patterns%20and%20colors%20arranged%20artistically%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20luxurious%20fabric%20sheen&width=600&height=600&seq=silk-ties-new&orientation=squarish',
    commission: 104.99,
    recurring: false,
  },
  {
    id: 57,
    name: 'Leather Belt - Italian Craftsmanship',
    price: 199.99,
    category: 'Fashion',
    description: 'Full-grain leather belt with RFID buckle and hand-stitched details',
    image: 'https://readdy.ai/api/search-image?query=premium%20leather%20belt%20in%20rich%20dark%20brown%20with%20polished%20RFID%20buckle%20and%20refined%20stitching%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20artisan%20quality&width=600&height=600&seq=leather-belt-new&orientation=squarish',
    commission: 59.99,
    recurring: false,
  },
  {
    id: 58,
    name: 'Wool Blazer - Tailored Fit',
    price: 799.99,
    category: 'Fashion',
    description: 'Premium wool blazer with modern cut and impeccable tailoring',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20navy%20blue%20wool%20blazer%20with%20sharp%20tailoring%20and%20modern%20slim%20fit%20displayed%20on%20dress%20form%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=wool-blazer-new&orientation=squarish',
    commission: 239.99,
    recurring: false,
  },
  {
    id: 59,
    name: 'Designer Crossbody Bag',
    price: 899.99,
    category: 'Fashion',
    description: 'Compact luxury crossbody bag with adjustable strap and signature hardware',
    image: 'https://readdy.ai/api/search-image?query=elegant%20compact%20crossbody%20handbag%20in%20soft%20beige%20leather%20with%20gold%20chain%20strap%20and%20designer%20hardware%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=crossbody-bag-new&orientation=squarish',
    commission: 269.99,
    recurring: false,
  },
  {
    id: 60,
    name: 'Cashmere Sweater - V-Neck',
    price: 399.99,
    category: 'Fashion',
    description: 'Lightweight cashmere sweater in timeless v-neck style with ribbed trim',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20cashmere%20v-neck%20sweater%20in%20soft%20gray%20color%20with%20elegant%20draping%20and%20refined%20knit%20texture%20displayed%20on%20clean%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=cashmere-sweater-new&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 61,
    name: 'Leather Wallet - RFID Protected',
    price: 149.99,
    category: 'Fashion',
    description: 'Slim leather wallet with RFID blocking and multiple card slots',
    image: 'https://readdy.ai/api/search-image?query=sleek%20minimalist%20leather%20wallet%20in%20black%20with%20multiple%20card%20slots%20and%20refined%20stitching%20displayed%20open%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=leather-wallet-new&orientation=squarish',
    commission: 44.99,
    recurring: false,
  },
  {
    id: 62,
    name: 'Silk Blouse - French Design',
    price: 499.99,
    category: 'Fashion',
    description: 'Elegant silk blouse with delicate details and flowing silhouette',
    image: 'https://readdy.ai/api/search-image?query=elegant%20silk%20blouse%20in%20soft%20ivory%20with%20flowing%20fabric%20and%20sophisticated%20design%20displayed%20on%20dress%20form%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=silk-blouse-new&orientation=squarish',
    commission: 149.99,
    recurring: false,
  },
  {
    id: 63,
    name: 'Designer Baseball Cap - Limited Edition',
    price: 179.99,
    category: 'Fashion',
    description: 'Premium cotton cap with embroidered logo and adjustable fit',
    image: 'https://readdy.ai/api/search-image?query=stylish%20baseball%20cap%20in%20clean%20black%20with%20subtle%20embroidered%20logo%20and%20curved%20brim%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20quality&width=600&height=600&seq=baseball-cap-new&orientation=squarish',
    commission: 53.99,
    recurring: false,
  },
  {
    id: 114,
    name: 'Burberry Trench Coat - Heritage Collection',
    price: 1899.99,
    category: 'Fashion',
    description: 'Iconic double-breasted trench coat in signature gabardine with check lining',
    image: 'https://readdy.ai/api/search-image?query=classic%20beige%20trench%20coat%20with%20double%20breasted%20buttons%20and%20belt%20displayed%20on%20dress%20form%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting%20showing%20timeless%20elegant%20design&width=600&height=600&seq=burberry-trench-new&orientation=squarish',
    commission: 569.99,
    recurring: false,
  },
  {
    id: 115,
    name: 'Gucci Loafers - Horsebit Detail',
    price: 899.99,
    category: 'Fashion',
    description: 'Classic leather loafers with signature horsebit hardware and premium finish',
    image: 'https://readdy.ai/api/search-image?query=elegant%20leather%20loafers%20in%20rich%20brown%20with%20gold%20metal%20horsebit%20detail%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20luxury%20craftsmanship&width=600&height=600&seq=gucci-loafers-new&orientation=squarish',
    commission: 269.99,
    recurring: false,
  },
  {
    id: 116,
    name: 'Hermès Silk Scarf - Limited Print',
    price: 449.99,
    category: 'Fashion',
    description: 'Hand-rolled silk scarf with exclusive artistic print and vibrant colors',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20silk%20scarf%20with%20colorful%20artistic%20pattern%20and%20hand%20rolled%20edges%20beautifully%20arranged%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20silk%20quality&width=600&height=600&seq=hermes-scarf-new&orientation=squarish',
    commission: 134.99,
    recurring: false,
  },
  {
    id: 117,
    name: 'Ray-Ban Aviator Sunglasses - Gold Frame',
    price: 199.99,
    category: 'Fashion',
    description: 'Iconic aviator sunglasses with gold metal frame and gradient lenses',
    image: 'https://readdy.ai/api/search-image?query=classic%20aviator%20sunglasses%20with%20gold%20metal%20frame%20and%20dark%20gradient%20lenses%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20timeless%20style&width=600&height=600&seq=rayban-aviator-new&orientation=squarish',
    commission: 59.99,
    recurring: false,
  },
  {
    id: 118,
    name: 'Levi\'s 501 Original Jeans - Vintage Wash',
    price: 129.99,
    category: 'Fashion',
    description: 'Classic straight-leg jeans in authentic vintage wash with button fly',
    image: 'https://readdy.ai/api/search-image?query=classic%20blue%20denim%20jeans%20in%20vintage%20wash%20with%20straight%20leg%20fit%20displayed%20on%20pristine%20white%20background%20with%20professional%20studio%20lighting%20showing%20authentic%20denim%20quality&width=600&height=600&seq=levis-501-new&orientation=squarish',
    commission: 38.99,
    recurring: false,
  },
  {
    id: 119,
    name: 'Canada Goose Parka - Arctic Edition',
    price: 1299.99,
    category: 'Fashion',
    description: 'Extreme cold weather parka with coyote fur trim and down insulation',
    image: 'https://readdy.ai/api/search-image?query=premium%20winter%20parka%20jacket%20in%20navy%20blue%20with%20fur%20trimmed%20hood%20and%20multiple%20pockets%20displayed%20on%20dress%20form%20against%20pristine%20white%20background%20with%20professional%20lighting&width=600&height=600&seq=canada-goose-new&orientation=squarish',
    commission: 389.99,
    recurring: false,
  },
  {
    id: 120,
    name: 'Tiffany & Co. Silver Bracelet',
    price: 349.99,
    category: 'Fashion',
    description: 'Sterling silver chain bracelet with signature heart tag charm',
    image: 'https://readdy.ai/api/search-image?query=elegant%20sterling%20silver%20bracelet%20with%20heart%20charm%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20luxury%20jewelry%20craftsmanship&width=600&height=600&seq=tiffany-bracelet-new&orientation=squarish',
    commission: 104.99,
    recurring: false,
  },
  {
    id: 121,
    name: 'Nike Air Jordan 1 Retro High',
    price: 179.99,
    category: 'Fashion',
    description: 'Iconic basketball sneakers in classic colorway with premium leather',
    image: 'https://readdy.ai/api/search-image?query=iconic%20high%20top%20basketball%20sneakers%20in%20red%20white%20and%20black%20colorway%20with%20premium%20leather%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=air-jordan1-new&orientation=squarish',
    commission: 53.99,
    recurring: false,
  },
  {
    id: 122,
    name: 'Patagonia Down Sweater Jacket',
    price: 279.99,
    category: 'Fashion',
    description: 'Lightweight packable down jacket with recycled materials and water-resistant finish',
    image: 'https://readdy.ai/api/search-image?query=lightweight%20quilted%20down%20jacket%20in%20forest%20green%20with%20minimalist%20design%20displayed%20on%20pristine%20white%20background%20with%20professional%20studio%20lighting%20showing%20outdoor%20performance%20wear&width=600&height=600&seq=patagonia-down-new&orientation=squarish',
    commission: 83.99,
    recurring: false,
  },
  {
    id: 123,
    name: 'Cartier Love Bracelet - Rose Gold',
    price: 6999.99,
    category: 'Fashion',
    description: 'Iconic 18k rose gold bracelet with signature screw motif and screwdriver',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20rose%20gold%20bangle%20bracelet%20with%20screw%20details%20displayed%20in%20elegant%20jewelry%20box%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20high%20end%20jewelry&width=600&height=600&seq=cartier-love-new&orientation=squarish',
    commission: 2099.99,
    recurring: false,
  },

  // ========== TRAVEL (18+ more products) ==========
  {
    id: 19,
    name: 'European Grand Tour - 14 Days',
    price: 3999.99,
    category: 'Travel',
    description: 'Luxury guided tour through Paris, Rome, Venice, and Barcelona with 5-star hotels',
    image: 'https://readdy.ai/api/search-image?query=iconic%20european%20landmarks%20including%20eiffel%20tower%20and%20colosseum%20in%20beautiful%20collage%20style%20with%20elegant%20travel%20theme%20on%20clean%20background%20representing%20luxury%20vacation%20tour%20package&width=600&height=600&seq=europe1&orientation=squarish',
    commission: 1199.99,
    recurring: false,
  },
  {
    id: 20,
    name: 'Caribbean Cruise - 10 Night Package',
    price: 2799.99,
    category: 'Travel',
    description: 'All-inclusive luxury cruise with balcony suite and unlimited dining',
    image: 'https://readdy.ai/api/search-image?query=elegant%20cruise%20ship%20sailing%20on%20crystal%20clear%20turquoise%20caribbean%20waters%20with%20white%20hull%20and%20multiple%20decks%20under%20bright%20blue%20sky%20representing%20luxury%20vacation%20cruise%20experience&width=600&height=600&seq=cruise1&orientation=squarish',
    commission: 839.99,
    recurring: false,
  },
  {
    id: 21,
    name: 'Safari Adventure - Kenya & Tanzania',
    price: 5499.99,
    category: 'Travel',
    description: '12-day luxury safari with game drives, hot air balloon ride, and premium lodges',
    image: 'https://readdy.ai/api/search-image?query=majestic%20african%20safari%20landscape%20with%20acacia%20trees%20and%20wildlife%20silhouettes%20at%20golden%20sunset%20representing%20luxury%20safari%20adventure%20vacation%20in%20pristine%20natural%20setting&width=600&height=600&seq=safari1&orientation=squarish',
    commission: 1649.99,
    recurring: false,
  },
  {
    id: 22,
    name: 'Ski Resort Package - Swiss Alps',
    price: 3299.99,
    category: 'Travel',
    description: '7-day luxury ski vacation with slope-side chalet and lift passes included',
    image: 'https://readdy.ai/api/search-image?query=stunning%20snow%20covered%20mountain%20peaks%20in%20swiss%20alps%20with%20luxury%20ski%20resort%20and%20pristine%20white%20slopes%20under%20clear%20blue%20sky%20representing%20premium%20winter%20vacation%20destination&width=600&height=600&seq=ski1&orientation=squarish',
    commission: 989.99,
    recurring: false,
  },
  {
    id: 64,
    name: 'Bali Wellness Retreat - 10 Days',
    price: 2999.99,
    category: 'Travel',
    description: 'Luxury wellness retreat with yoga, spa treatments, and organic cuisine in Ubud',
    image: 'https://readdy.ai/api/search-image?query=serene%20balinese%20wellness%20retreat%20with%20traditional%20architecture%20surrounded%20by%20lush%20tropical%20rice%20terraces%20and%20palm%20trees%20under%20golden%20sunlight%20representing%20peaceful%20luxury%20spa%20vacation&width=600&height=600&seq=bali-retreat-new&orientation=squarish',
    commission: 899.99,
    recurring: false,
  },
  {
    id: 65,
    name: 'Iceland Northern Lights Tour - 8 Days',
    price: 3499.99,
    category: 'Travel',
    description: 'Winter adventure with aurora viewing, glacier hiking, and geothermal spa visits',
    image: 'https://readdy.ai/api/search-image?query=spectacular%20northern%20lights%20aurora%20borealis%20dancing%20over%20snowy%20icelandic%20landscape%20with%20mountains%20and%20frozen%20lake%20creating%20magical%20winter%20scene%20representing%20luxury%20arctic%20vacation&width=600&height=600&seq=iceland-lights-new&orientation=squarish',
    commission: 1049.99,
    recurring: false,
  },
  {
    id: 66,
    name: 'Japan Cultural Experience - 12 Days',
    price: 4299.99,
    category: 'Travel',
    description: 'Immersive journey through Tokyo, Kyoto, and Osaka with traditional ryokan stays',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20japanese%20temple%20with%20traditional%20architecture%20and%20cherry%20blossom%20trees%20in%20full%20bloom%20with%20mount%20fuji%20in%20background%20representing%20elegant%20cultural%20vacation%20in%20japan&width=600&height=600&seq=japan-culture-new&orientation=squarish',
    commission: 1289.99,
    recurring: false,
  },
  {
    id: 67,
    name: 'Greek Islands Yacht Charter - 7 Days',
    price: 6999.99,
    category: 'Travel',
    description: 'Private yacht cruise through Santorini, Mykonos, and Crete with crew and chef',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20white%20yacht%20sailing%20near%20iconic%20white%20buildings%20with%20blue%20domes%20of%20santorini%20greece%20over%20crystal%20clear%20aegean%20sea%20representing%20premium%20mediterranean%20vacation&width=600&height=600&seq=greek-yacht-new&orientation=squarish',
    commission: 2099.99,
    recurring: false,
  },
  {
    id: 68,
    name: 'New Zealand Adventure - 14 Days',
    price: 4799.99,
    category: 'Travel',
    description: 'Epic journey through both islands with hiking, wine tours, and luxury lodges',
    image: 'https://readdy.ai/api/search-image?query=breathtaking%20new%20zealand%20landscape%20with%20dramatic%20mountains%20turquoise%20lake%20and%20lush%20green%20valleys%20under%20clear%20blue%20sky%20representing%20adventure%20luxury%20vacation%20destination&width=600&height=600&seq=newzealand-adventure-new&orientation=squarish',
    commission: 1439.99,
    recurring: false,
  },
  {
    id: 69,
    name: 'Dubai Luxury Experience - 5 Days',
    price: 3799.99,
    category: 'Travel',
    description: '5-star hotel stay with desert safari, yacht cruise, and fine dining experiences',
    image: 'https://readdy.ai/api/search-image?query=stunning%20dubai%20skyline%20with%20burj%20khalifa%20and%20modern%20skyscrapers%20reflecting%20in%20water%20at%20sunset%20with%20golden%20light%20representing%20luxury%20middle%20east%20vacation%20destination&width=600&height=600&seq=dubai-luxury-new&orientation=squarish',
    commission: 1139.99,
    recurring: false,
  },
  {
    id: 70,
    name: 'Amazon Rainforest Expedition - 9 Days',
    price: 3999.99,
    category: 'Travel',
    description: 'Eco-luxury adventure with wildlife viewing, river cruises, and expert guides',
    image: 'https://readdy.ai/api/search-image?query=lush%20amazon%20rainforest%20with%20dense%20green%20canopy%20and%20winding%20river%20from%20aerial%20view%20with%20exotic%20birds%20and%20pristine%20nature%20representing%20eco%20luxury%20adventure%20vacation&width=600&height=600&seq=amazon-expedition-new&orientation=squarish',
    commission: 1199.99,
    recurring: false,
  },
  {
    id: 71,
    name: 'Morocco Imperial Cities Tour - 10 Days',
    price: 2899.99,
    category: 'Travel',
    description: 'Cultural journey through Marrakech, Fes, and Casablanca with riad accommodations',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20moroccan%20architecture%20with%20intricate%20tile%20work%20colorful%20market%20souks%20and%20traditional%20riads%20in%20warm%20golden%20light%20representing%20exotic%20cultural%20vacation%20in%20north%20africa&width=600&height=600&seq=morocco-tour-new&orientation=squarish',
    commission: 869.99,
    recurring: false,
  },
  {
    id: 72,
    name: 'Patagonia Trekking Adventure - 11 Days',
    price: 4499.99,
    category: 'Travel',
    description: 'Guided hiking expedition through Torres del Paine with luxury camping',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20patagonia%20mountain%20peaks%20with%20glaciers%20and%20pristine%20lakes%20in%20stunning%20natural%20landscape%20under%20dramatic%20sky%20representing%20adventure%20luxury%20trekking%20vacation&width=600&height=600&seq=patagonia-trek-new&orientation=squarish',
    commission: 1349.99,
    recurring: false,
  },
  {
    id: 124,
    name: 'Australian Outback & Reef - 15 Days',
    price: 5999.99,
    category: 'Travel',
    description: 'Complete Australia experience: Sydney, Great Barrier Reef, and Uluru with luxury lodges',
    image: 'https://readdy.ai/api/search-image?query=stunning%20great%20barrier%20reef%20coral%20underwater%20scene%20with%20vibrant%20marine%20life%20and%20sydney%20opera%20house%20in%20background%20representing%20complete%20australian%20luxury%20vacation%20experience&width=600&height=600&seq=australia-complete-new&orientation=squarish',
    commission: 1799.99,
    recurring: false,
  },
  {
    id: 125,
    name: 'Norwegian Fjords Cruise - 8 Days',
    price: 3299.99,
    category: 'Travel',
    description: 'Scenic cruise through dramatic fjords with stops in Bergen, Geiranger, and Tromsø',
    image: 'https://readdy.ai/api/search-image?query=majestic%20norwegian%20fjord%20with%20steep%20cliffs%20towering%20waterfalls%20and%20cruise%20ship%20sailing%20through%20calm%20blue%20waters%20representing%20scenic%20nordic%20luxury%20vacation&width=600&height=600&seq=norway-fjords-new&orientation=squarish',
    commission: 989.99,
    recurring: false,
  },
  {
    id: 126,
    name: 'Peru Machu Picchu Explorer - 10 Days',
    price: 3799.99,
    category: 'Travel',
    description: 'Ancient Inca trail trek to Machu Picchu with luxury hotels in Cusco and Sacred Valley',
    image: 'https://readdy.ai/api/search-image?query=breathtaking%20machu%20picchu%20ancient%20ruins%20on%20mountain%20top%20with%20dramatic%20clouds%20and%20lush%20green%20valleys%20representing%20iconic%20peru%20cultural%20adventure%20vacation&width=600&height=600&seq=peru-machu-new&orientation=squarish',
    commission: 1139.99,
    recurring: false,
  },
  {
    id: 127,
    name: 'Thailand Island Hopping - 12 Days',
    price: 2999.99,
    category: 'Travel',
    description: 'Luxury beach resort tour through Phuket, Koh Samui, and Krabi with private transfers',
    image: 'https://readdy.ai/api/search-image?query=pristine%20tropical%20beach%20in%20thailand%20with%20crystal%20clear%20turquoise%20water%20white%20sand%20and%20traditional%20longtail%20boats%20representing%20luxury%20island%20paradise%20vacation&width=600&height=600&seq=thailand-islands-new&orientation=squarish',
    commission: 899.99,
    recurring: false,
  },
  {
    id: 128,
    name: 'Egypt Nile River Cruise - 9 Days',
    price: 3499.99,
    category: 'Travel',
    description: 'Luxury river cruise from Cairo to Aswan with guided tours of pyramids and temples',
    image: 'https://readdy.ai/api/search-image?query=ancient%20egyptian%20pyramids%20and%20sphinx%20with%20luxury%20cruise%20ship%20on%20nile%20river%20at%20sunset%20representing%20historic%20cultural%20luxury%20vacation%20in%20egypt&width=600&height=600&seq=egypt-nile-new&orientation=squarish',
    commission: 1049.99,
    recurring: false,
  },
  {
    id: 129,
    name: 'South Africa Wine Country - 8 Days',
    price: 3199.99,
    category: 'Travel',
    description: 'Cape Town and Stellenbosch wine tour with luxury vineyard stays and tastings',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20south%20african%20vineyard%20with%20rows%20of%20grapevines%20and%20mountains%20in%20background%20with%20elegant%20wine%20estate%20representing%20luxury%20wine%20country%20vacation&width=600&height=600&seq=south-africa-wine-new&orientation=squarish',
    commission: 959.99,
    recurring: false,
  },
  {
    id: 130,
    name: 'Galapagos Islands Expedition - 10 Days',
    price: 6499.99,
    category: 'Travel',
    description: 'Naturalist-guided cruise with wildlife encounters and luxury yacht accommodations',
    image: 'https://readdy.ai/api/search-image?query=galapagos%20islands%20with%20unique%20wildlife%20giant%20tortoises%20and%20pristine%20volcanic%20landscape%20with%20luxury%20yacht%20representing%20exclusive%20eco%20adventure%20vacation&width=600&height=600&seq=galapagos-expedition-new&orientation=squarish',
    commission: 1949.99,
    recurring: false,
  },

  // ========== GOURMET (18+ more products) ==========
  {
    id: 23,
    name: 'Premium Coffee Subscription',
    price: 79.99,
    category: 'Gourmet',
    description: 'Monthly delivery of specialty coffee beans from top roasters worldwide',
    image: 'https://readdy.ai/api/search-image?query=premium%20coffee%20beans%20in%20elegant%20packaging%20with%20coffee%20cup%20and%20brewing%20equipment%20arranged%20beautifully%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20lighting%20and%20minimalist%20styling&width=600&height=600&seq=coffee1&orientation=squarish',
    commission: 23.99,
    recurring: true,
    recurringNote: 'Monthly',
  },
  {
    id: 24,
    name: 'Organic Meal Kit Subscription',
    price: 199.99,
    category: 'Gourmet',
    description: 'Weekly delivery of chef-designed meals with organic ingredients and recipes',
    image: 'https://readdy.ai/api/search-image?query=fresh%20organic%20vegetables%20herbs%20and%20premium%20ingredients%20arranged%20in%20elegant%20meal%20kit%20box%20on%20clean%20white%20surface%20with%20natural%20lighting%20showing%20healthy%20colorful%20produce&width=600&height=600&seq=mealkit1&orientation=squarish',
    commission: 59.99,
    recurring: true,
    recurringNote: 'Weekly',
  },
  {
    id: 25,
    name: 'Wine Club Membership - Premium Tier',
    price: 299.99,
    category: 'Gourmet',
    description: 'Monthly selection of 6 premium wines curated by expert sommeliers',
    image: 'https://readdy.ai/api/search-image?query=elegant%20wine%20bottles%20with%20sophisticated%20labels%20arranged%20with%20wine%20glasses%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20rich%20dark%20color&width=600&height=600&seq=wine1&orientation=squarish',
    commission: 89.99,
    recurring: true,
    recurringNote: 'Monthly',
  },
  {
    id: 26,
    name: 'Artisan Chocolate Subscription',
    price: 69.99,
    category: 'Gourmet',
    description: 'Monthly box of handcrafted chocolates from award-winning chocolatiers',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20handcrafted%20chocolates%20in%20elegant%20box%20with%20various%20flavors%20and%20artistic%20designs%20displayed%20on%20clean%20white%20surface%20with%20soft%20professional%20lighting&width=600&height=600&seq=chocolate1&orientation=squarish',
    commission: 20.99,
    recurring: true,
    recurringNote: 'Monthly',
  },
  {
    id: 73,
    name: 'Truffle Collection - Black & White',
    price: 399.99,
    category: 'Gourmet',
    description: 'Premium fresh truffles with truffle oil and shaver for gourmet cooking',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20black%20and%20white%20truffles%20displayed%20in%20elegant%20wooden%20box%20with%20truffle%20oil%20bottles%20and%20shaver%20on%20pristine%20white%20marble%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=truffle-collection-new&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 74,
    name: 'Aged Balsamic Vinegar Set - 25 Years',
    price: 249.99,
    category: 'Gourmet',
    description: 'Traditional Italian balsamic vinegar aged in wooden barrels with tasting notes',
    image: 'https://readdy.ai/api/search-image?query=elegant%20glass%20bottles%20of%20aged%20balsamic%20vinegar%20with%20sophisticated%20labels%20arranged%20on%20clean%20white%20marble%20surface%20with%20fresh%20olives%20and%20herbs%20with%20professional%20studio%20lighting&width=600&height=600&seq=balsamic-set-new&orientation=squarish',
    commission: 74.99,
    recurring: false,
  },
  {
    id: 75,
    name: 'Caviar Tasting Collection',
    price: 599.99,
    category: 'Gourmet',
    description: 'Selection of premium caviar varieties with mother-of-pearl spoons',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20reusable%20silicone%20food%20storage%20bags%20in%20different%20sizes%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20eco%20friendly%20kitchen%20products&width=600&height=600&seq=reusable-food-bags&orientation=squarish',
    commission: 5.39,
    recurring: false,
  },
  {
    id: 76,
    name: 'Japanese Wagyu Beef - A5 Grade',
    price: 349.99,
    category: 'Gourmet',
    description: 'Premium A5 Wagyu beef steaks with exceptional marbling and flavor',
    image: 'https://readdy.ai/api/search-image?query=premium%20wagyu%20beef%20steaks%20with%20beautiful%20marbling%20displayed%20on%20elegant%20white%20plate%20with%20minimal%20garnish%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=wagyu-beef-new&orientation=squarish',
    commission: 104.99,
    recurring: false,
  },
  {
    id: 77,
    name: 'Artisan Cheese Board Collection',
    price: 179.99,
    category: 'Gourmet',
    description: 'Curated selection of 8 premium cheeses from European artisan producers',
    image: 'https://readdy.ai/api/search-image?query=elegant%20cheese%20board%20with%20variety%20of%20artisan%20cheeses%20fruits%20nuts%20and%20crackers%20beautifully%20arranged%20on%20wooden%20board%20on%20pristine%20white%20surface%20with%20professional%20lighting&width=600&height=600&seq=cheese-board-new&orientation=squarish',
    commission: 53.99,
    recurring: false,
  },
  {
    id: 78,
    name: 'Single Origin Olive Oil Collection',
    price: 149.99,
    category: 'Gourmet',
    description: 'Set of 4 extra virgin olive oils from renowned Mediterranean estates',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20makeup%20sponges%20in%20different%20shapes%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20beauty%20application%20tools&width=600&height=600&seq=makeup-sponge-set&orientation=squarish',
    commission: 3.89,
    recurring: false,
  },
  {
    id: 79,
    name: 'Himalayan Pink Salt Collection',
    price: 89.99,
    category: 'Gourmet',
    description: 'Premium pink salt in various grinds with salt block for cooking',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20pink%20himalayan%20salt%20crystals%20in%20elegant%20glass%20jars%20with%20salt%20block%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20natural%20pink%20color&width=600&height=600&seq=himalayan-salt-new&orientation=squarish',
    commission: 26.99,
    recurring: false,
  },
  {
    id: 80,
    name: 'Saffron Threads - Premium Grade',
    price: 199.99,
    category: 'Gourmet',
    description: 'Highest quality saffron threads from Kashmir with authentication certificate',
    image: 'https://readdy.ai/api/search-image?query=delicate%20red%20saffron%20threads%20in%20elegant%20glass%20container%20with%20golden%20accents%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20quality&width=600&height=600&seq=saffron-threads-new&orientation=squarish',
    commission: 59.99,
    recurring: false,
  },
  {
    id: 81,
    name: 'Craft Beer Subscription - Rare Brews',
    price: 119.99,
    category: 'Gourmet',
    description: 'Monthly selection of 12 limited edition craft beers from microbreweries',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20craft%20beer%20bottles%20with%20artistic%20labels%20arranged%20in%20elegant%20wooden%20crate%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20variety%20of%20styles&width=600&height=600&seq=craft-beer-sub-new&orientation=squarish',
    commission: 35.99,
    recurring: true,
    recurringNote: 'Monthly',
  },
  {
    id: 131,
    name: 'Iberico Ham - 36 Month Aged',
    price: 299.99,
    category: 'Gourmet',
    description: 'Premium Spanish Iberico de Bellota ham, hand-carved and vacuum sealed',
    image: 'https://readdy.ai/api/search-image?query=premium%20spanish%20iberico%20ham%20slices%20arranged%20elegantly%20on%20white%20plate%20with%20olive%20oil%20and%20bread%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=iberico-ham-new&orientation=squarish',
    commission: 89.99,
    recurring: false,
  },
  {
    id: 132,
    name: 'Champagne Collection - Vintage Selection',
    price: 499.99,
    category: 'Gourmet',
    description: 'Set of 3 vintage champagne bottles from prestigious French houses',
    image: 'https://readdy.ai/api/search-image?query=elegant%20champagne%20bottles%20with%20gold%20foil%20and%20sophisticated%20labels%20arranged%20with%20crystal%20flutes%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=champagne-collection-new&orientation=squarish',
    commission: 149.99,
    recurring: false,
  },
  {
    id: 133,
    name: 'Matcha Tea Ceremony Set - Premium Grade',
    price: 179.99,
    category: 'Gourmet',
    description: 'Authentic Japanese matcha powder with traditional bamboo whisk and ceramic bowl',
    image: 'https://readdy.ai/api/search-image?query=traditional%20japanese%20matcha%20tea%20set%20with%20bamboo%20whisk%20ceramic%20bowl%20and%20vibrant%20green%20matcha%20powder%20arranged%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=matcha-ceremony-new&orientation=squarish',
    commission: 53.99,
    recurring: false,
  },
  {
    id: 134,
    name: 'Foie Gras - French Delicacy',
    price: 249.99,
    category: 'Gourmet',
    description: 'Premium duck foie gras from Southwest France with fig compote',
    image: 'https://readdy.ai/api/search-image?query=elegant%20foie%20gras%20terrine%20sliced%20on%20white%20plate%20with%20fig%20compote%20and%20toasted%20bread%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=foie-gras-new&orientation=squarish',
    commission: 74.99,
    recurring: false,
  },
  {
    id: 135,
    name: 'Artisan Pasta Making Kit',
    price: 129.99,
    category: 'Gourmet',
    description: 'Complete Italian pasta kit with premium flour, tools, and recipe book',
    image: 'https://readdy.ai/api/search-image?query=artisan%20pasta%20making%20tools%20with%20fresh%20pasta%20dough%20flour%20and%20rolling%20pin%20arranged%20beautifully%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=pasta-kit-new&orientation=squarish',
    commission: 38.99,
    recurring: false,
  },
  {
    id: 136,
    name: 'Smoked Salmon - Norwegian Premium',
    price: 89.99,
    category: 'Gourmet',
    description: 'Wild-caught Norwegian salmon, cold-smoked with traditional methods',
    image: 'https://readdy.ai/api/search-image?query=premium%20smoked%20salmon%20slices%20arranged%20elegantly%20on%20white%20plate%20with%20capers%20lemon%20and%20dill%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=smoked-salmon-new&orientation=squarish',
    commission: 26.99,
    recurring: false,
  },
  {
    id: 137,
    name: 'Honey Collection - Raw & Unfiltered',
    price: 99.99,
    category: 'Gourmet',
    description: 'Set of 5 raw honey varieties from different floral sources worldwide',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20glass%20honey%20jars%20with%20golden%20honey%20in%20various%20shades%20arranged%20with%20honeycomb%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=honey-collection-new&orientation=squarish',
    commission: 29.99,
    recurring: false,
  },
  {
    id: 138,
    name: 'Spice Blend Collection - World Flavors',
    price: 149.99,
    category: 'Gourmet',
    description: '12 premium spice blends from around the world in elegant glass jars',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20colorful%20spice%20blends%20in%20elegant%20glass%20jars%20with%20labels%20arranged%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20vibrant%20colors&width=600&height=600&seq=spice-collection-new&orientation=squarish',
    commission: 44.99,
    recurring: false,
  },

  // ========== HOME & LIVING (20+ more products) ==========
  {
    id: 31,
    name: 'Smart Home Security System',
    price: 899.99,
    category: 'Home & Living',
    description: 'Complete security system with cameras, sensors, and mobile app control',
    image: 'https://readdy.ai/api/search-image?query=modern%20smart%20home%20security%20camera%20and%20control%20panel%20with%20sleek%20white%20design%20displayed%20on%20clean%20surface%20showing%20mobile%20app%20interface%20with%20professional%20lighting%20in%20minimalist%20setting&width=600&height=600&seq=security1&orientation=squarish',
    commission: 269.99,
    recurring: false,
  },
  {
    id: 32,
    name: 'Luxury Bedding Collection - King Size',
    price: 599.99,
    category: 'Home & Living',
    description: 'Premium Egyptian cotton sheets, duvet, and pillows with 1000 thread count',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20white%20bedding%20set%20with%20premium%20cotton%20sheets%20elegant%20duvet%20and%20plush%20pillows%20beautifully%20arranged%20on%20bed%20in%20bright%20minimalist%20bedroom%20with%20soft%20natural%20lighting&width=600&height=600&seq=bedding1&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
  {
    id: 33,
    name: 'Designer Kitchen Appliance Set',
    price: 1799.99,
    category: 'Home & Living',
    description: 'Premium stainless steel appliances including mixer, blender, and coffee maker',
    image: 'https://readdy.ai/api/search-image?query=elegant%20stainless%20steel%20kitchen%20appliances%20including%20stand%20mixer%20blender%20and%20coffee%20maker%20arranged%20on%20clean%20white%20marble%20countertop%20with%20professional%20studio%20lighting&width=600&height=600&seq=kitchen1&orientation=squarish',
    commission: 539.99,
    recurring: false,
  },
  {
    id: 34,
    name: 'Smart Robot Vacuum Cleaner',
    price: 699.99,
    category: 'Home & Living',
    description: 'AI-powered robot vacuum with mapping, self-emptying, and app control',
    image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20robot%20vacuum%20cleaner%20with%20circular%20design%20and%20smart%20sensors%20displayed%20on%20pristine%20white%20floor%20showing%20the%20premium%20build%20quality%20with%20professional%20lighting&width=600&height=600&seq=vacuum1&orientation=squarish',
    commission: 209.99,
    recurring: false,
  },
  {
    id: 35,
    name: 'Luxury Indoor Plant Collection',
    price: 399.99,
    category: 'Home & Living',
    description: 'Curated set of 10 premium indoor plants with designer pots and care guide',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20collection%20of%20lush%20green%20indoor%20plants%20in%20elegant%20modern%20ceramic%20pots%20arranged%20artistically%20on%20clean%20white%20surface%20with%20natural%20lighting%20creating%20fresh%20botanical%20atmosphere&width=600&height=600&seq=plants1&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 82,
    name: 'Scandinavian Dining Table Set',
    price: 1899.99,
    category: 'Home & Living',
    description: 'Solid oak dining table with 6 chairs in minimalist Nordic design',
    image: 'https://readdy.ai/api/search-image?query=elegant%20scandinavian%20dining%20table%20in%20light%20oak%20wood%20with%20six%20modern%20chairs%20in%20minimalist%20design%20displayed%20in%20bright%20white%20room%20with%20professional%20lighting&width=600&height=600&seq=dining-table-new&orientation=squarish',
    commission: 569.99,
    recurring: false,
  },
  {
    id: 83,
    name: 'Designer Floor Lamp - Arc Style',
    price: 549.99,
    category: 'Home & Living',
    description: 'Modern arc floor lamp with marble base and adjustable arm',
    image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20arc%20floor%20lamp%20with%20curved%20metal%20arm%20and%20marble%20base%20in%20minimalist%20design%20displayed%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=floor-lamp-new&orientation=squarish',
    commission: 164.99,
    recurring: false,
  },
  {
    id: 84,
    name: 'Luxury Throw Blanket - Alpaca Wool',
    price: 299.99,
    category: 'Home & Living',
    description: 'Ultra-soft alpaca wool blanket in neutral tones with fringe detail',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20soft%20alpaca%20wool%20throw%20blanket%20in%20neutral%20beige%20draped%20elegantly%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20texture&width=600&height=600&seq=throw-blanket-new&orientation=squarish',
    commission: 89.99,
    recurring: false,
  },
  {
    id: 85,
    name: 'Smart Thermostat - Energy Saving',
    price: 249.99,
    category: 'Home & Living',
    description: 'WiFi-enabled thermostat with learning capabilities and remote control',
    image: 'https://readdy.ai/api/search-image?query=modern%20smart%20thermostat%20with%20sleek%20circular%20display%20showing%20temperature%20settings%20mounted%20on%20pristine%20white%20wall%20with%20professional%20lighting&width=600&height=600&seq=smart-thermostat-new&orientation=squarish',
    commission: 74.99,
    recurring: false,
  },
  {
    id: 86,
    name: 'Handwoven Area Rug - Persian Style',
    price: 1299.99,
    category: 'Home & Living',
    description: 'Authentic handwoven rug with intricate patterns in rich colors',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20handwoven%20area%20rug%20with%20intricate%20persian%20patterns%20in%20rich%20colors%20displayed%20on%20pristine%20white%20floor%20with%20professional%20studio%20lighting%20showing%20detailed%20craftsmanship&width=600&height=600&seq=area-rug-new&orientation=squarish',
    commission: 389.99,
    recurring: false,
  },
  {
    id: 87,
    name: 'Crystal Chandelier - Modern Design',
    price: 1599.99,
    category: 'Home & Living',
    description: 'Contemporary crystal chandelier with LED lighting and dimmer',
    image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20crystal%20chandelier%20with%20geometric%20design%20and%20sparkling%20crystals%20displayed%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=chandelier-new&orientation=squarish',
    commission: 479.99,
    recurring: false,
  },
  {
    id: 88,
    name: 'Velvet Sofa - 3 Seater',
    price: 2499.99,
    category: 'Home & Living',
    description: 'Luxurious velvet sofa in deep emerald with gold legs and plush cushions',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20emerald%20green%20velvet%20sofa%20with%20elegant%20gold%20legs%20and%20plush%20cushions%20displayed%20in%20bright%20minimalist%20room%20with%20professional%20lighting&width=600&height=600&seq=velvet-sofa-new&orientation=squarish',
    commission: 749.99,
    recurring: false,
  },
  {
    id: 89,
    name: 'Marble Coffee Table - Round',
    price: 899.99,
    category: 'Home & Living',
    description: 'White marble top coffee table with brass frame in modern design',
    image: 'https://readdy.ai/api/search-image?query=elegant%20round%20coffee%20table%20with%20white%20marble%20top%20and%20brass%20metal%20frame%20in%20modern%20minimalist%20design%20displayed%20on%20pristine%20white%20floor%20with%20professional%20lighting&width=600&height=600&seq=coffee-table-new&orientation=squarish',
    commission: 269.99,
    recurring: false,
  },
  {
    id: 90,
    name: 'Aromatherapy Diffuser - Premium',
    price: 149.99,
    category: 'Home & Living',
    description: 'Ultrasonic essential oil diffuser with LED lights and timer',
    image: 'https://readdy.ai/api/search-image?query=elegant%20aromatherapy%20diffuser%20with%20sleek%20modern%20design%20emitting%20gentle%20mist%20with%20soft%20ambient%20lighting%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=diffuser-new&orientation=squarish',
    commission: 44.99,
    recurring: false,
  },
  {
    id: 91,
    name: 'Wall Art Set - Abstract Canvas',
    price: 499.99,
    category: 'Home & Living',
    description: 'Set of 3 large abstract canvas prints in coordinating colors',
    image: 'https://readdy.ai/api/search-image?query=modern%20abstract%20canvas%20art%20prints%20in%20teal%20and%20gold%20tones%20displayed%20as%20set%20of%20three%20on%20pristine%20white%20wall%20with%20professional%20gallery%20lighting&width=600&height=600&seq=wall-art-new&orientation=squarish',
    commission: 149.99,
    recurring: false,
  },
  {
    id: 139,
    name: 'KitchenAid Stand Mixer - Artisan Series',
    price: 449.99,
    category: 'Home & Living',
    description: '5-quart tilt-head stand mixer with 10 speeds and multiple attachments',
    image: 'https://readdy.ai/api/search-image?query=iconic%20stand%20mixer%20in%20vibrant%20red%20color%20with%20stainless%20steel%20bowl%20and%20attachments%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=kitchenaid-mixer-new&orientation=squarish',
    commission: 134.99,
    recurring: false,
  },
  {
    id: 140,
    name: 'Le Creuset Dutch Oven - 7.25 Quart',
    price: 399.99,
    category: 'Home & Living',
    description: 'Enameled cast iron Dutch oven in signature color with lifetime warranty',
    image: 'https://readdy.ai/api/search-image?query=premium%20cast%20iron%20dutch%20oven%20in%20vibrant%20orange%20with%20enamel%20coating%20and%20lid%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=le-creuset-new&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 141,
    name: 'Nespresso Vertuo Coffee Machine',
    price: 199.99,
    category: 'Home & Living',
    description: 'Premium coffee and espresso maker with one-touch brewing and milk frother',
    image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20coffee%20machine%20in%20matte%20black%20with%20capsule%20system%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=nespresso-vertuo-new&orientation=squarish',
    commission: 59.99,
    recurring: false,
  },
  {
    id: 142,
    name: 'Brooklinen Luxury Sheet Set',
    price: 149.99,
    category: 'Home & Living',
    description: 'Premium percale cotton sheets with 480 thread count in queen size',
    image: 'https://readdy.ai/api/search-image?query=crisp%20white%20cotton%20bed%20sheets%20neatly%20folded%20with%20elegant%20packaging%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=brooklinen-sheets-new&orientation=squarish',
    commission: 44.99,
    recurring: false,
  },
  {
    id: 143,
    name: 'Casper Original Mattress - Queen',
    price: 1095.99,
    category: 'Home & Living',
    description: 'Award-winning memory foam mattress with zoned support and cooling technology',
    image: 'https://readdy.ai/api/search-image?query=modern%20memory%20foam%20mattress%20with%20multiple%20layers%20shown%20in%20cross%20section%20displayed%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=casper-mattress-new&orientation=squarish',
    commission: 328.79,
    recurring: false,
  },
  {
    id: 144,
    name: 'Vitamix Professional Blender',
    price: 599.99,
    category: 'Home & Living',
    description: 'High-performance blender with 2.2 HP motor and self-cleaning function',
    image: 'https://readdy.ai/api/search-image?query=powerful%20professional%20blender%20in%20sleek%20black%20with%20large%20container%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=vitamix-blender-new&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
  {
    id: 145,
    name: 'West Elm Mid-Century Bookshelf',
    price: 799.99,
    category: 'Home & Living',
    description: 'Solid wood bookshelf with 5 shelves in walnut finish and brass accents',
    image: 'https://readdy.ai/api/search-image?query=elegant%20mid%20century%20modern%20bookshelf%20in%20walnut%20wood%20with%20clean%20lines%20and%20brass%20details%20displayed%20against%20pristine%20white%20background%20with%20professional%20lighting&width=600&height=600&seq=west-elm-bookshelf-new&orientation=squarish',
    commission: 239.99,
    recurring: false,
  },
  {
    id: 146,
    name: 'Instant Pot Duo Plus - 8 Quart',
    price: 129.99,
    category: 'Home & Living',
    description: '9-in-1 electric pressure cooker with sterilizer and yogurt maker',
    image: 'https://readdy.ai/api/search-image?query=modern%20electric%20pressure%20cooker%20in%20stainless%20steel%20with%20digital%20display%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=instant-pot-new&orientation=squarish',
    commission: 38.99,
    recurring: false,
  },
  {
    id: 147,
    name: 'Pottery Barn Leather Armchair',
    price: 1499.99,
    category: 'Home & Living',
    description: 'Top-grain leather armchair with nailhead trim and hardwood frame',
    image: 'https://readdy.ai/api/search-image?query=classic%20leather%20armchair%20in%20rich%20brown%20with%20nailhead%20details%20and%20elegant%20design%20displayed%20against%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=pottery-barn-chair-new&orientation=squarish',
    commission: 449.99,
    recurring: false,
  },
  {
    id: 148,
    name: 'Crate & Barrel Bar Cart',
    price: 399.99,
    category: 'Home & Living',
    description: 'Modern brass bar cart with glass shelves and rolling casters',
    image: 'https://readdy.ai/api/search-image?query=elegant%20brass%20bar%20cart%20with%20glass%20shelves%20and%20wheels%20displaying%20bottles%20and%20glassware%20on%20pristine%20white%20background%20with%20professional%20studio%20lighting&width=600&height=600&seq=bar-cart-new&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },

  // ========== HEALTH & FITNESS (20+ more products) ==========
  {
    id: 15,
    name: 'Smart Treadmill with Interactive Display',
    price: 2499.99,
    category: 'Health & Fitness',
    description: 'Professional-grade treadmill with 22-inch touchscreen and live classes',
    image: 'https://readdy.ai/api/search-image?query=modern%20smart%20treadmill%20with%20large%20touchscreen%20display%20showing%20workout%20interface%20in%20clean%20white%20minimalist%20home%20gym%20space%20with%20professional%20lighting%20and%20sleek%20contemporary%20design&width=600&height=600&seq=treadmill1&orientation=squarish',
    commission: 749.99,
    recurring: false,
  },
  {
    id: 16,
    name: 'Professional Standing Desk Setup',
    price: 1299.99,
    category: 'Health & Fitness',
    description: 'Electric height-adjustable desk with memory presets and cable management',
    image: 'https://readdy.ai/api/search-image?query=modern%20electric%20standing%20desk%20with%20clean%20wooden%20top%20and%20sleek%20metal%20frame%20in%20bright%20minimalist%20office%20space%20with%20laptop%20and%20minimal%20accessories%20on%20pristine%20white%20background&width=600&height=600&seq=desk1&orientation=squarish',
    commission: 389.99,
    recurring: false,
  },
  {
    id: 17,
    name: 'Premium Yoga & Pilates Equipment Set',
    price: 399.99,
    category: 'Health & Fitness',
    description: 'Complete set with mat, blocks, straps, and resistance bands for home practice',
    image: 'https://readdy.ai/api/search-image?query=elegant%20yoga%20and%20pilates%20equipment%20set%20with%20premium%20mat%20blocks%20straps%20and%20accessories%20arranged%20beautifully%20on%20clean%20white%20floor%20in%20bright%20minimalist%20space%20with%20soft%20natural%20lighting&width=600&height=600&seq=yoga1&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 18,
    name: 'Smart Fitness Watch - Premium Edition',
    price: 799.99,
    category: 'Health & Fitness',
    description: 'Advanced fitness tracker with GPS, heart rate monitor, and health insights',
    image: 'https://readdy.ai/api/search-image?query=premium%20smart%20fitness%20watch%20with%20sleek%20metal%20band%20and%20vibrant%20display%20showing%20health%20metrics%20on%20screen%20displayed%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=smartwatch1&orientation=squarish',
    commission: 239.99,
    recurring: false,
  },
  {
    id: 92,
    name: 'Adjustable Dumbbell Set - 5-52.5 lbs',
    price: 599.99,
    category: 'Health & Fitness',
    description: 'Space-saving adjustable dumbbells replacing 15 sets of weights',
    image: 'https://readdy.ai/api/search-image?query=modern%20adjustable%20dumbbells%20with%20quick%20dial%20system%20in%20sleek%20black%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20compact%20space%20saving%20design&width=600&height=600&seq=dumbbells-new&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
  {
    id: 93,
    name: 'Rowing Machine - Water Resistance',
    price: 1899.99,
    category: 'Health & Fitness',
    description: 'Premium water rowing machine with natural resistance and performance monitor',
    image: 'https://readdy.ai/api/search-image?query=modern%20wooden%20rowing%20machine%20with%20water%20tank%20and%20sleek%20design%20displayed%20in%20bright%20minimalist%20home%20gym%20with%20professional%20lighting%20showing%20premium%20craftsmanship&width=600&height=600&seq=rowing-machine-new&orientation=squarish',
    commission: 569.99,
    recurring: false,
  },
  {
    id: 94,
    name: 'Massage Gun - Professional Grade',
    price: 349.99,
    category: 'Health & Fitness',
    description: 'Deep tissue percussion massager with 6 attachments and quiet motor',
    image: 'https://readdy.ai/api/search-image?query=professional%20massage%20gun%20with%20multiple%20attachment%20heads%20in%20sleek%20black%20design%20displayed%20with%20carrying%20case%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=massage-gun-new&orientation=squarish',
    commission: 104.99,
    recurring: false,
  },
  {
    id: 95,
    name: 'Resistance Bands Set - Premium',
    price: 79.99,
    category: 'Health & Fitness',
    description: 'Complete set of 5 resistance bands with handles, door anchor, and bag',
    image: 'https://readdy.ai/api/search-image?query=colorful%20resistance%20bands%20set%20with%20handles%20and%20accessories%20arranged%20neatly%20on%20clean%20white%20surface%20with%20professional%20studio%20lighting%20showing%20various%20resistance%20levels&width=600&height=600&seq=resistance-bands-new&orientation=squarish',
    commission: 23.99,
    recurring: false,
  },
  {
    id: 96,
    name: 'Foam Roller Set - Muscle Recovery',
    price: 89.99,
    category: 'Health & Fitness',
    description: 'High-density foam rollers in 3 sizes for deep tissue massage',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20foam%20rollers%20in%20different%20sizes%20with%20textured%20surface%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20premium%20quality%20materials&width=600&height=600&seq=foam-rollers-new&orientation=squarish',
    commission: 26.99,
    recurring: false,
  },
  {
    id: 97,
    name: 'Smart Scale - Body Composition',
    price: 129.99,
    category: 'Health & Fitness',
    description: 'WiFi scale tracking weight, body fat, muscle mass, and 12 other metrics',
    image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20smart%20scale%20with%20digital%20display%20in%20minimalist%20white%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=smart-scale-new&orientation=squarish',
    commission: 38.99,
    recurring: false,
  },
  {
    id: 98,
    name: 'Kettlebell Set - Cast Iron',
    price: 299.99,
    category: 'Health & Fitness',
    description: 'Professional kettlebell set with 3 weights: 15, 25, and 35 lbs',
    image: 'https://readdy.ai/api/search-image?query=set%20of%20three%20cast%20iron%20kettlebells%20in%20different%20sizes%20with%20smooth%20finish%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20solid%20construction&width=600&height=600&seq=kettlebell-set-new&orientation=squarish',
    commission: 89.99,
    recurring: false,
  },
  {
    id: 99,
    name: 'Exercise Bike - Indoor Cycling',
    price: 1499.99,
    category: 'Health & Fitness',
    description: 'Studio-quality spin bike with magnetic resistance and performance tracking',
    image: 'https://readdy.ai/api/search-image?query=modern%20indoor%20exercise%20bike%20with%20sleek%20black%20design%20and%20digital%20display%20in%20bright%20minimalist%20home%20gym%20with%20professional%20lighting&width=600&height=600&seq=exercise-bike-new&orientation=squarish',
    commission: 449.99,
    recurring: false,
  },
  {
    id: 100,
    name: 'Protein Powder - Premium Blend',
    price: 69.99,
    category: 'Health & Fitness',
    description: 'Grass-fed whey protein with 25g protein per serving, 5 lb container',
    image: 'https://readdy.ai/api/search-image?query=premium%20protein%20powder%20container%20with%20clean%20modern%20label%20design%20and%20scoop%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=protein-powder-new&orientation=squarish',
    commission: 20.99,
    recurring: false,
  },
  {
    id: 101,
    name: 'Yoga Mat - Eco-Friendly Cork',
    price: 129.99,
    category: 'Health & Fitness',
    description: 'Natural cork yoga mat with rubber base, non-slip and sustainable',
    image: 'https://readdy.ai/api/search-image?query=elegant%20cork%20yoga%20mat%20rolled%20and%20unrolled%20showing%20natural%20texture%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20highlighting%20eco%20friendly%20materials&width=600&height=600&seq=cork-yoga-mat-new&orientation=squarish',
    commission: 38.99,
    recurring: false,
  },
  {
    id: 102,
    name: 'Pull-Up Bar - Doorway Mounted',
    price: 49.99,
    category: 'Health & Fitness',
    description: 'Heavy-duty pull-up bar with multiple grip positions, no drilling required',
    image: 'https://readdy.ai/api/search-image?query=sturdy%20doorway%20pull%20up%20bar%20with%20padded%20grips%20in%20black%20metal%20finish%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20solid%20construction&width=600&height=600&seq=pullup-bar-new&orientation=squarish',
    commission: 14.99,
    recurring: false,
  },
  {
    id: 149,
    name: 'Peloton Bike+ - Premium Package',
    price: 2495.99,
    category: 'Health & Fitness',
    description: 'Connected fitness bike with rotating HD touchscreen and auto-resistance',
    image: 'https://readdy.ai/api/search-image?query=premium%20connected%20exercise%20bike%20with%20large%20rotating%20touchscreen%20in%20sleek%20black%20design%20displayed%20in%20bright%20minimalist%20home%20gym%20with%20professional%20lighting&width=600&height=600&seq=peloton-bike-new&orientation=squarish',
    commission: 748.79,
    recurring: false,
  },
  {
    id: 150,
    name: 'TRX Suspension Training System',
    price: 199.99,
    category: 'Health & Fitness',
    description: 'Professional suspension trainer with door anchor and workout guide',
    image: 'https://readdy.ai/api/search-image?query=suspension%20training%20straps%20in%20black%20and%20yellow%20with%20handles%20and%20anchor%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=trx-system-new&orientation=squarish',
    commission: 59.99,
    recurring: false,
  },
  {
    id: 151,
    name: 'Fitbit Charge 6 Fitness Tracker',
    price: 159.99,
    category: 'Health & Fitness',
    description: 'Advanced fitness band with heart rate monitoring and 7-day battery life',
    image: 'https://readdy.ai/api/search-image?query=sleek%20fitness%20tracker%20band%20in%20black%20with%20digital%20display%20showing%20health%20metrics%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=fitbit-charge6-new&orientation=squarish',
    commission: 47.99,
    recurring: false,
  },
  {
    id: 152,
    name: 'NordicTrack Elliptical - Commercial Series',
    price: 1999.99,
    category: 'Health & Fitness',
    description: 'Commercial-grade elliptical with 26 resistance levels and iFit integration',
    image: 'https://readdy.ai/api/search-image?query=professional%20elliptical%20machine%20with%20large%20stride%20and%20digital%20console%20in%20sleek%20design%20displayed%20in%20bright%20minimalist%20home%20gym%20with%20professional%20lighting&width=600&height=600&seq=nordictrack-elliptical-new&orientation=squarish',
    commission: 599.99,
    recurring: false,
  },
  {
    id: 153,
    name: 'Hyperice Hypervolt 2 Pro',
    price: 399.99,
    category: 'Health & Fitness',
    description: 'Bluetooth-enabled percussion massage device with pressure sensor',
    image: 'https://readdy.ai/api/search-image?query=premium%20percussion%20massage%20device%20in%20sleek%20white%20and%20black%20design%20with%20multiple%20heads%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=hyperice-hypervolt-new&orientation=squarish',
    commission: 119.99,
    recurring: false,
  },
  {
    id: 154,
    name: 'Bowflex SelectTech 1090 Dumbbells',
    price: 799.99,
    category: 'Health & Fitness',
    description: 'Adjustable dumbbells from 10 to 90 lbs with rapid weight change system',
    image: 'https://readdy.ai/api/search-image?query=adjustable%20dumbbells%20with%20dial%20system%20in%20black%20and%20red%20design%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting%20showing%20weight%20adjustment%20mechanism&width=600&height=600&seq=bowflex-selecttech-new&orientation=squarish',
    commission: 239.99,
    recurring: false,
  },
  {
    id: 155,
    name: 'Manduka PRO Yoga Mat',
    price: 138.99,
    category: 'Health & Fitness',
    description: 'Professional-grade yoga mat with lifetime guarantee and superior grip',
    image: 'https://readdy.ai/api/search-image?query=premium%20yoga%20mat%20in%20deep%20purple%20color%20rolled%20and%20unrolled%20showing%20thick%20cushioning%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=manduka-pro-new&orientation=squarish',
    commission: 41.69,
    recurring: false,
  },
  {
    id: 156,
    name: 'Garmin Forerunner 965 GPS Watch',
    price: 599.99,
    category: 'Health & Fitness',
    description: 'Premium running watch with AMOLED display and advanced training metrics',
    image: 'https://readdy.ai/api/search-image?query=premium%20GPS%20running%20watch%20with%20colorful%20AMOLED%20display%20showing%20fitness%20data%20displayed%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=garmin-forerunner-new&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
  {
    id: 157,
    name: 'Concept2 Model D Indoor Rower',
    price: 1015.99,
    category: 'Health & Fitness',
    description: 'Professional rowing machine with PM5 monitor used by Olympic athletes',
    image: 'https://readdy.ai/api/search-image?query=professional%20indoor%20rowing%20machine%20in%20black%20with%20performance%20monitor%20displayed%20in%20bright%20minimalist%20home%20gym%20with%20professional%20lighting%20showing%20commercial%20quality&width=600&height=600&seq=concept2-rower-new&orientation=squarish',
    commission: 304.79,
    recurring: false,
  },
  {
    id: 158,
    name: 'Theragun PRO Plus Massager',
    price: 599.99,
    category: 'Health & Fitness',
    description: 'Professional-grade percussive therapy device with OLED screen and app',
    image: 'https://readdy.ai/api/search-image?query=professional%20massage%20gun%20with%20OLED%20screen%20and%20multiple%20attachments%20in%20premium%20black%20design%20displayed%20with%20case%20on%20pristine%20white%20surface%20with%20professional%20studio%20lighting&width=600&height=600&seq=theragun-pro-new&orientation=squarish',
    commission: 179.99,
    recurring: false,
  },
];
